import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import React, { forwardRef, useState, useRef, useEffect, useMemo, createElement, Fragment as Fragment$1, useCallback, useImperativeHandle } from "react";
import { styled, Box, Button as Button$1, CircularProgress as CircularProgress$1, Popper, Grow, Paper, ClickAwayListener, MenuList as MenuList$1, MenuItem, ButtonGroup as ButtonGroup$1, TextField, InputAdornment, Select, FormControl, InputLabel, FormHelperText, Link, Checkbox, IconButton as IconButton$1, ListItemText, Tooltip, ToggleButtonGroup as ToggleButtonGroup$1, Stack, Autocomplete as Autocomplete$1, Divider, ListItemIcon, createFilterOptions, alpha, useTheme, AppBar as AppBar$1, Toolbar, Dialog as Dialog$1, DialogTitle as DialogTitle$1, Chip, DialogContent as DialogContent$1, DialogActions as DialogActions$1, Slide, Accordion, AccordionSummary, AccordionDetails, Avatar as Avatar$1, Menu as Menu$2, useMediaQuery, Snackbar as Snackbar$1, Portal, Fade } from "@mui/material";
import { OpenInNewOutlined, VisibilityOffOutlined, VisibilityOutlined, Cancel, ContentCopyOutlined, AddCircleOutlineOutlined, MenuOutlined, MoreVertOutlined, HelpOutline, ErrorOutline, CloseOutlined, Check, TodayOutlined } from "@mui/icons-material";
import { u as useTranslationWithFallback, T as Typography, c as ICON_SIZE_SMALL, i as IconButton, f as MENU_ITEM_SIZE_DENSE, d as MENU_LIST_MAX_SIZE, h as MENU_ITEM_SIZE_EXTENDED, M as MENU_ITEM_SIZE_DEFAULT, A as APPBAR_SIZE, j as useImperativeIntl, b as ICON_SIZE_MEDIUM, N as NOTIFICATION_DURATION_IN_MS, e as ellipsisStyles } from "../css-utils-CjUBRJVK.js";
import { a } from "../css-utils-CjUBRJVK.js";
import { S as ScreenReaderOnly, A as Alert$1 } from "../Alert-BZPM5zpX.js";
import { L } from "../Alert-BZPM5zpX.js";
import { A as ArrowDown } from "../ArrowDown-d6bxUL0F.js";
import { A as ArrowUp, O as OpenDiagonallyRight, C as CloseDiagonallyRight } from "../OpenDiagonallyRight-CGdCEXlF.js";
import { M as MenuItem$1 } from "../MenuItem-DRUK149i.js";
import "cartocolor";
import { FixedSizeList } from "react-window";
import { Controlled, UnControlled } from "react-codemirror2";
import { lime, blue, purple, teal, red, green, indigo } from "@mui/material/colors";
import "codemirror/lib/codemirror.css";
import "codemirror/lib/codemirror.js";
import "codemirror/mode/sql/sql.js";
import "codemirror/mode/javascript/javascript.js";
import "codemirror/mode/htmlmixed/htmlmixed.js";
import "codemirror/mode/markdown/markdown.js";
import "codemirror/mode/shell/shell.js";
import "codemirror/mode/python/python.js";
import "codemirror/addon/display/placeholder";
import "codemirror/addon/hint/sql-hint.js";
import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/show-hint.js";
import "codemirror/addon/selection/active-line.js";
import "codemirror/addon/edit/matchbrackets.js";
import "codemirror/addon/fold/foldcode.js";
import "codemirror/addon/fold/foldgutter.js";
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/addon/fold/brace-fold.js";
import "codemirror/addon/fold/xml-fold.js";
import "codemirror/addon/fold/indent-fold.js";
import "codemirror/addon/fold/markdown-fold.js";
import "codemirror/addon/fold/comment-fold.js";
import ClickAwayListener$1 from "@mui/material/ClickAwayListener";
import { DatePicker as DatePicker$1 } from "@mui/x-date-pickers/DatePicker";
import { useIntl } from "react-intl";
import { PickersDay as PickersDay$1 } from "@mui/x-date-pickers";
import { TimePicker as TimePicker$1 } from "@mui/x-date-pickers/TimePicker";
import { DateTimePicker as DateTimePicker$1 } from "@mui/x-date-pickers/DateTimePicker";
import { S as Search } from "../Search-C7wkXu3f.js";
import DOMPurify from "dompurify";
const IndicatorIcon = styled(Box)({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});
const HiddenText = styled(Box)({
  visibility: "hidden",
  pointerEvents: "none"
});
function _Button({
  children,
  loading,
  disabled,
  startIcon,
  endIcon,
  loadingPosition,
  external,
  showExternalIcon = true,
  screenReaderText,
  "aria-describedby": ariaDescribedby,
  ...otherProps
}, ref) {
  const screenReaderTextValue = useTranslationWithFallback(
    "c4r.button.opensInNewTab",
    screenReaderText
  );
  const defaultIconLoader = /* @__PURE__ */ jsx(CircularProgress$1, { size: 18, color: "inherit" });
  const isDefaultLoading = loading && loadingPosition === void 0;
  const isExternalLink = otherProps.href && external;
  const renderContent = () => {
    if (isDefaultLoading) {
      return /* @__PURE__ */ jsxs(Box, { sx: { position: "relative" }, children: [
        /* @__PURE__ */ jsx(IndicatorIcon, { children: defaultIconLoader }),
        /* @__PURE__ */ jsx(HiddenText, { children })
      ] });
    }
    if (isExternalLink) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        children,
        /* @__PURE__ */ jsx(ScreenReaderOnly, { id: "external-hint", children: screenReaderTextValue })
      ] });
    }
    return children;
  };
  const getIconForPosition = (position) => {
    if (isDefaultLoading) {
      return void 0;
    }
    if (loading && loadingPosition !== void 0) {
      if (loadingPosition === position) {
        return defaultIconLoader;
      }
      return void 0;
    }
    if (position === "start") {
      return startIcon;
    } else {
      return endIcon || (isExternalLink && showExternalIcon ? /* @__PURE__ */ jsx(OpenInNewOutlined, {}) : void 0);
    }
  };
  return /* @__PURE__ */ jsx(
    Button$1,
    {
      disabled: loading || disabled,
      startIcon: getIconForPosition("start"),
      endIcon: getIconForPosition("end"),
      ...otherProps,
      role: otherProps.href ? "link" : "button",
      ...isExternalLink && {
        target: "_blank",
        rel: "noopener noreferrer"
      },
      ref,
      "aria-describedby": isExternalLink ? "external-hint" : ariaDescribedby,
      children: /* @__PURE__ */ jsx(Typography, { variant: "inherit", color: "inherit", noWrap: true, component: "span", children: renderContent() })
    }
  );
}
const Button = forwardRef(_Button);
const ButtonGroup = styled(ButtonGroup$1)(({ theme, size }) => ({
  "& .MuiButton-root:last-child": {
    padding: 0,
    minWidth: size === "small" ? theme.spacing(3) : size === "large" ? theme.spacing(6) : theme.spacing(4)
  }
}));
function SplitButton({
  options,
  disabled,
  loading,
  loadingPosition,
  onClick,
  variant,
  size,
  color,
  ...otherProps
}) {
  var _a;
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const handleClick = () => {
    onClick(options[selectedIndex]);
  };
  const handleMenuItemClick = (_, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleClose = (event) => {
    var _a2;
    if ((_a2 = anchorRef.current) == null ? void 0 : _a2.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      ButtonGroup,
      {
        "data-name": "split-button",
        ref: anchorRef,
        variant,
        size,
        color,
        ...otherProps,
        children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              disabled,
              loading,
              loadingPosition,
              onClick: handleClick,
              children: (_a = options[selectedIndex]) == null ? void 0 : _a.label
            }
          ),
          /* @__PURE__ */ jsx(Button, { disabled: loading || disabled, onClick: handleToggle, children: open ? /* @__PURE__ */ jsx(ArrowUp, {}) : /* @__PURE__ */ jsx(ArrowDown, {}) })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      Popper,
      {
        sx: { zIndex: 1 },
        open,
        anchorEl: anchorRef.current,
        role: void 0,
        transition: true,
        disablePortal: true,
        placement: "bottom-end",
        children: ({ TransitionProps, placement }) => /* @__PURE__ */ jsx(
          Grow,
          {
            ...TransitionProps,
            style: {
              transformOrigin: placement === "bottom" ? "center top" : "center bottom"
            },
            children: /* @__PURE__ */ jsx(Paper, { elevation: 8, children: /* @__PURE__ */ jsx(ClickAwayListener, { onClickAway: handleClose, children: /* @__PURE__ */ jsx(MenuList$1, { autoFocusItem: true, sx: { paddingY: 1 }, children: options.map((option, index) => /* @__PURE__ */ jsx(
              MenuItem,
              {
                disabled: option.disabled,
                selected: index === selectedIndex,
                onClick: (event) => handleMenuItemClick(event, index),
                children: option.label
              },
              option.label
            )) }) }) })
          }
        )
      }
    )
  ] });
}
const Root$5 = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5)
}));
const Indicator = styled(Typography)(({ theme }) => ({
  ".Mui-disabled &": {
    color: theme.palette.text.disabled
  }
}));
const Icon = styled(Box)(({ theme }) => ({
  display: "flex",
  svg: {
    width: ICON_SIZE_SMALL,
    height: ICON_SIZE_SMALL,
    fontSize: ICON_SIZE_SMALL,
    path: {
      fill: theme.palette.text.secondary,
      ".Mui-disabled &": {
        fill: theme.palette.text.disabled
      }
    }
  }
}));
function _LabelWithIndicator({
  label,
  type,
  icon,
  inheritSize,
  "data-testid": dataTestId,
  "aria-label": ariaLabel,
  typographyProps
}, ref) {
  return /* @__PURE__ */ jsxs(
    Root$5,
    {
      ref,
      "data-testid": dataTestId,
      "aria-label": ariaLabel,
      "data-icon": !!icon,
      "data-name": "label-with-indicator",
      children: [
        label,
        type && /* @__PURE__ */ jsx(
          Indicator,
          {
            component: "span",
            variant: inheritSize ? "inherit" : "caption",
            color: "textSecondary",
            weight: "regular",
            ...typographyProps,
            children: type === "required" ? "(required)" : "(optional)"
          }
        ),
        icon && /* @__PURE__ */ jsx(Icon, { children: icon })
      ]
    }
  );
}
const LabelWithIndicator = forwardRef(_LabelWithIndicator);
function _PasswordField({
  InputProps,
  size = "small",
  disabled,
  showPasswordText,
  hidePasswordText,
  ...otherProps
}, ref) {
  const showPasswordLabel = useTranslationWithFallback(
    "c4r.form.showPassword",
    showPasswordText
  );
  const hidePasswordLabel = useTranslationWithFallback(
    "c4r.form.hidePassword",
    hidePasswordText
  );
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const label = showPassword ? hidePasswordLabel : showPasswordLabel;
  return /* @__PURE__ */ jsx(
    TextField,
    {
      ...otherProps,
      ref,
      type: showPassword ? "text" : "password",
      size,
      disabled,
      InputProps: {
        ...InputProps,
        inputProps: {
          ...InputProps == null ? void 0 : InputProps.inputProps,
          role: "textbox"
        },
        endAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "end", children: /* @__PURE__ */ jsx(
          IconButton,
          {
            size,
            disabled,
            onClick: handleClickShowPassword,
            icon: showPassword ? /* @__PURE__ */ jsx(VisibilityOffOutlined, {}) : /* @__PURE__ */ jsx(VisibilityOutlined, {}),
            tooltip: label,
            "aria-label": label
          }
        ) })
      },
      "data-name": "password-field"
    }
  );
}
const PasswordField = forwardRef(_PasswordField);
const idCounter = {};
function uniqueId(prefix = "$lodash$") {
  if (!idCounter[prefix]) {
    idCounter[prefix] = 0;
  }
  const id = ++idCounter[prefix];
  if (prefix === "$lodash$") {
    return `${id}`;
  }
  return `${prefix}${id}`;
}
const StyledSelect = styled(Select)(({ theme }) => ({
  "& .MuiInputAdornment-positionStart": {
    paddingLeft: theme.spacing(2),
    "&.MuiInputAdornment-sizeSmall": {
      paddingLeft: theme.spacing(1.5)
    }
  },
  "& .MuiInputBase-inputAdornedStart": {
    paddingLeft: "0px !important"
  },
  "& .MuiSelect-select .MuiMenuItem-root:hover": {
    backgroundColor: "transparent"
  },
  "&.MuiInputBase-root .MuiSelect-select.MuiSelect-multiple": {
    paddingRight: theme.spacing(7)
  }
}));
const PlaceholderItem = styled(MenuItem)(() => ({
  display: "none"
}));
function _SelectField({
  children,
  placeholder,
  size = "small",
  displayEmpty,
  menuProps,
  inputProps,
  labelId,
  label,
  labelSecondary,
  helperText,
  name,
  error,
  focused,
  disabled,
  fullWidth,
  required,
  "aria-label": ariaLabel,
  ...otherProps
}, ref) {
  const isSmall = size === "small";
  const [defaultId] = useState(() => uniqueId("select-label-"));
  const ariaLabelledBy = label ? labelId ?? defaultId : void 0;
  return /* @__PURE__ */ jsxs(
    FormControl,
    {
      size,
      error,
      focused,
      disabled,
      fullWidth,
      required,
      "data-name": "select-field",
      "data-size": size,
      children: [
        /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
          label && /* @__PURE__ */ jsx(InputLabel, { shrink: true, id: ariaLabelledBy, children: label }),
          labelSecondary && /* @__PURE__ */ jsx(Box, { display: "flex", alignItems: "center", ml: 2, mb: 0.5, children: labelSecondary })
        ] }),
        /* @__PURE__ */ jsxs(
          StyledSelect,
          {
            ...otherProps,
            labelId: ariaLabelledBy,
            name,
            ref,
            size,
            fullWidth,
            displayEmpty: displayEmpty ?? !!placeholder,
            inputProps: {
              ...inputProps,
              "aria-label": ariaLabel
            },
            MenuProps: {
              ...menuProps,
              PopoverClasses: {
                paper: isSmall ? "MuiMenu-paper-sizeSmall" : void 0
              },
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
              },
              transformOrigin: {
                vertical: 0,
                horizontal: "left"
              }
            },
            children: [
              placeholder && /* @__PURE__ */ jsx(PlaceholderItem, { disabled: true, value: "", children: /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: isSmall ? "body2" : "body1",
                  color: "text.hint",
                  component: "span",
                  children: placeholder
                }
              ) }),
              children
            ]
          }
        ),
        helperText && /* @__PURE__ */ jsx(FormHelperText, { "aria-label": `${name}-helper`, children: helperText })
      ]
    }
  );
}
const SelectField = forwardRef(_SelectField);
function useMultipleSelectField({
  selectedOptions,
  options,
  onChange
}) {
  const [currentOptions, setCurrentOptions] = useState(selectedOptions ?? []);
  const isInternalUpdate = useRef(false);
  useEffect(() => {
    if (!isInternalUpdate.current) {
      setCurrentOptions(selectedOptions ?? []);
    }
    isInternalUpdate.current = false;
  }, [selectedOptions]);
  const enabledOptions = useMemo(
    () => options.filter(({ disabled }) => !disabled),
    [options]
  );
  const enabledOptionValues = useMemo(
    () => enabledOptions.map(({ value }) => value),
    [enabledOptions]
  );
  const areAllSelected = enabledOptionValues.length > 0 && enabledOptionValues.every((value) => currentOptions.includes(value));
  const areAnySelected = currentOptions.length > 0;
  const handleChange = (event) => {
    if (isInternalUpdate.current) {
      return;
    }
    const {
      target: { value }
    } = event;
    const newOptions = typeof value === "string" ? value.split(",") : value.filter((v) => v !== void 0);
    setCurrentOptions(newOptions);
    onChange(newOptions);
  };
  const selectAll = () => {
    const optionsValues = options == null ? void 0 : options.filter(({ disabled }) => !disabled).map(({ value }) => value);
    if (optionsValues) {
      const allSelected = optionsValues.every(
        (value) => currentOptions.includes(value)
      );
      const newValue = allSelected ? [] : optionsValues;
      isInternalUpdate.current = true;
      setCurrentOptions(newValue);
      onChange(newValue);
    }
  };
  const unselectAll = () => {
    const newValue = [];
    isInternalUpdate.current = true;
    setCurrentOptions(newValue);
    onChange(newValue);
  };
  return {
    areAllSelected,
    areAnySelected,
    currentOptions,
    handleChange,
    selectAll,
    unselectAll
  };
}
const StyledMenuItem$1 = styled(MenuItem$1)(() => ({
  marginTop: "0 !important",
  marginBottom: "0 !important"
}));
const LinkFilter = styled(Link)(
  ({ disabled, theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    width: "100%",
    textAlign: "initial",
    ...disabled && {
      pointerEvents: "none",
      color: theme.palette.text.disabled
    }
  })
);
function _MenuItemFilter({
  areAllSelected,
  areAnySelected,
  selectAll,
  selectAllDisabled,
  selectAllText,
  "aria-label": ariaLabel,
  "data-testid": dataTestId
}, ref) {
  const selectAllLabel = useTranslationWithFallback(
    "c4r.form.selectAll",
    selectAllText
  );
  return /* @__PURE__ */ jsx(
    StyledMenuItem$1,
    {
      ref,
      fixed: true,
      "data-name": "menu-filter",
      "aria-label": ariaLabel,
      "data-testid": dataTestId,
      children: /* @__PURE__ */ jsxs(
        LinkFilter,
        {
          variant: "body2",
          color: "textPrimary",
          component: "button",
          underline: "none",
          disabled: !!selectAllDisabled,
          onClick: selectAll,
          tabIndex: 0,
          children: [
            /* @__PURE__ */ jsx(
              Checkbox,
              {
                checked: areAllSelected,
                indeterminate: areAnySelected && !areAllSelected,
                disabled: selectAllDisabled
              }
            ),
            selectAllLabel
          ]
        }
      )
    }
  );
}
const MenuItemFilter = forwardRef(_MenuItemFilter);
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  "&.Mui-disabled": {
    pointerEvents: "auto",
    "&:hover": {
      backgroundColor: `${theme.palette.background.default} !important`
    }
  }
}));
const UnselectButton = styled(InputAdornment, {
  shouldForwardProp: (prop) => prop !== "size"
})(({ theme, size }) => ({
  display: "none",
  position: "absolute",
  top: theme.spacing(2),
  right: theme.spacing(3.5),
  ".MuiInputBase-root:hover &, .MuiInputBase-root.Mui-focused &": {
    display: "flex"
  },
  ".MuiSvgIcon-root": {
    color: theme.palette.text.hint
  },
  ...size === "medium" && {
    top: theme.spacing(3),
    right: theme.spacing(5)
  }
}));
const EMPTY_ARRAY = [];
const EMPTY_FN = () => void 0;
function _MultipleSelectField({
  options = EMPTY_ARRAY,
  selectedOptions,
  size = "small",
  placeholder,
  showCounter,
  showFilters = true,
  onChange = EMPTY_FN,
  selectAllDisabled,
  tooltipPlacement,
  variant,
  allSelectedText,
  noneSelectedText,
  selectedText,
  selectAllText,
  ...props
}, ref) {
  const {
    areAllSelected,
    areAnySelected,
    currentOptions,
    handleChange,
    selectAll,
    unselectAll
  } = useMultipleSelectField({
    options,
    selectedOptions,
    onChange
  });
  const isSmall = size === "small";
  const paddingSize = isSmall || variant === "standard" ? 0 : 2;
  const allSelectedLabel = useTranslationWithFallback(
    "c4r.form.allSelected",
    allSelectedText
  );
  const noneSelectedLabel = useTranslationWithFallback(
    "c4r.form.noneSelected",
    noneSelectedText
  );
  const selectedLabel = useTranslationWithFallback(
    "c4r.form.selected",
    selectedText
  );
  const counterText = `${currentOptions.length} ${selectedLabel}`;
  const renderValue = useMemo(() => {
    if (areAllSelected) {
      return /* @__PURE__ */ jsx(
        Typography,
        {
          component: "span",
          variant: isSmall ? "body2" : "body1",
          color: "textPrimary",
          ml: paddingSize,
          children: allSelectedLabel
        }
      );
    }
    if (areAnySelected) {
      return /* @__PURE__ */ jsx(
        Typography,
        {
          component: "span",
          variant: isSmall ? "body2" : "body1",
          color: "textPrimary",
          ml: paddingSize,
          children: showCounter && currentOptions.length > 1 ? counterText : currentOptions.join(", ")
        }
      );
    }
    return /* @__PURE__ */ jsx(
      Typography,
      {
        component: "span",
        variant: isSmall ? "body2" : "body1",
        color: "text.hint",
        ml: paddingSize,
        children: placeholder ?? noneSelectedLabel
      }
    );
  }, [
    areAllSelected,
    areAnySelected,
    allSelectedLabel,
    counterText,
    currentOptions,
    isSmall,
    noneSelectedLabel,
    paddingSize,
    placeholder,
    showCounter
  ]);
  return /* @__PURE__ */ jsxs(
    SelectField,
    {
      ...props,
      ref,
      multiple: true,
      displayEmpty: true,
      placeholder,
      value: currentOptions,
      renderValue: () => renderValue,
      onChange: handleChange,
      size,
      variant,
      endAdornment: showFilters && areAnySelected && /* @__PURE__ */ jsx(UnselectButton, { position: "end", size, children: /* @__PURE__ */ jsx(IconButton$1, { onClick: unselectAll, size, children: /* @__PURE__ */ jsx(Cancel, {}) }) }),
      menuProps: {
        PaperProps: {
          sx: {
            ".MuiList-root": {
              paddingTop: 0
            }
          }
        }
      },
      children: [
        showFilters && /* @__PURE__ */ jsx(
          Box,
          {
            sx: {
              mb: 1
            },
            children: /* @__PURE__ */ jsx(
              MenuItemFilter,
              {
                areAllSelected,
                areAnySelected,
                selectAll,
                selectAllDisabled,
                selectAllText
              }
            )
          }
        ),
        options == null ? void 0 : options.map((option) => {
          const item = /* @__PURE__ */ jsxs(
            StyledMenuItem,
            {
              value: option.value,
              disabled: option.disabled,
              tabIndex: 0,
              children: [
                /* @__PURE__ */ jsx(
                  Checkbox,
                  {
                    disabled: option.disabled,
                    checked: currentOptions.includes(option.value)
                  }
                ),
                /* @__PURE__ */ jsx(ListItemText, { primary: option.label })
              ]
            },
            option.value
          );
          const content = option.tooltip ? /* @__PURE__ */ jsx(
            Tooltip,
            {
              title: option.tooltip,
              placement: tooltipPlacement,
              children: item
            },
            option.value
          ) : item;
          return content;
        })
      ]
    }
  );
}
const MultipleSelectField = forwardRef(_MultipleSelectField);
const StyledToggleButtonGroup = styled(ToggleButtonGroup$1, {
  shouldForwardProp: (prop) => prop !== "backgroundColor"
})();
function _ToggleButtonGroup({
  children,
  variant = "floating",
  backgroundColor,
  orientation,
  size,
  ...rest
}, ref) {
  const isUnbounded = variant === "unbounded";
  const defaultColor = isUnbounded ? "transparent" : "primary";
  const resolvedBackgroundColor = backgroundColor ?? defaultColor;
  return /* @__PURE__ */ jsx(
    StyledToggleButtonGroup,
    {
      ...rest,
      ref,
      variant,
      backgroundColor: resolvedBackgroundColor,
      orientation,
      size,
      "data-orientation": orientation,
      "data-variant": variant,
      "data-size": size,
      "data-background-color": resolvedBackgroundColor,
      "data-name": "toggle-button-group",
      children
    }
  );
}
const ToggleButtonGroup = forwardRef(_ToggleButtonGroup);
function _CircularProgress({
  color = "primary",
  size = 40,
  thickness = 4,
  ...otherProps
}, ref) {
  const muiColor = color === "neutral" ? void 0 : color;
  return /* @__PURE__ */ jsx(
    CircularProgress$1,
    {
      ...otherProps,
      ref,
      size,
      thickness,
      color: muiColor,
      "data-name": "circular-progress",
      "data-color": color,
      "data-thickness": thickness
    }
  );
}
const CircularProgress = forwardRef(
  _CircularProgress
);
const Wrapper = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "contentHeight"
})(({ contentHeight, theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(1.5),
  width: "100%",
  ...contentHeight && {
    flex: 1,
    height: contentHeight,
    minHeight: contentHeight
  }
}));
function _Loader({
  label,
  secondLabel,
  contentHeight,
  labelProps,
  secondLabelProps,
  iconProps,
  sx,
  ...otherProps
}, ref) {
  const labelText = useTranslationWithFallback("c4r.utils.loader.label", label);
  const hasAnyLabel = labelText || secondLabel;
  return /* @__PURE__ */ jsxs(
    Wrapper,
    {
      contentHeight,
      sx,
      ...otherProps,
      ref,
      "aria-busy": true,
      "data-name": "loader",
      "data-content-height": contentHeight,
      children: [
        /* @__PURE__ */ jsx(
          CircularProgress,
          {
            color: "primary",
            size: 40,
            ...iconProps,
            "aria-labelledby": hasAnyLabel ? "loader-label" : void 0
          }
        ),
        hasAnyLabel && /* @__PURE__ */ jsxs(Stack, { direction: "column", alignItems: "center", children: [
          labelText && /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "body2",
              color: "textSecondary",
              ...labelProps,
              id: "loader-label",
              children: labelText
            }
          ),
          secondLabel && /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "body2",
              color: "textSecondary",
              ...secondLabelProps,
              id: labelText ? void 0 : "loader-label",
              children: secondLabel
            }
          )
        ] })
      ]
    }
  );
}
const Loader = forwardRef(_Loader);
async function copyString(value) {
  return await navigator.clipboard.writeText(value);
}
const useCopyValue = (msg = "c4r.button.copy", copiedMsg = "c4r.notifications.copiedToClipboard") => {
  const [message, setMessage] = useState(msg);
  const copy = async (text) => {
    await copyString(text);
    setMessage(copiedMsg);
    setTimeout(() => setMessage(msg), 1e3);
  };
  return {
    message,
    copy
  };
};
const _CopiableComponent = ({
  children,
  disabled,
  value,
  onCopied,
  copyText,
  copiedText,
  button,
  buttonLabel,
  buttonIcon,
  buttonProps,
  ariaLabel,
  dataTestId,
  tooltipPlacement = "top",
  tooltipProps,
  snackbarProps,
  ...props
}, ref) => {
  const [open, setOpen] = useState(false);
  const _copyText = useTranslationWithFallback("c4r.button.copy", copyText);
  const copyTooltipText = copyText === null ? null : _copyText;
  const copySuccessMessage = useTranslationWithFallback(
    "c4r.notifications.copiedToClipboard",
    copiedText
  );
  const { copy } = useCopyValue(copyTooltipText, copySuccessMessage);
  const handleClick = (e) => {
    e.preventDefault();
    copy(value).then(() => {
      onCopied == null ? void 0 : onCopied();
      setOpen(true);
    }).catch(console.error);
  };
  const copyIcon = buttonIcon ?? /* @__PURE__ */ jsx(ContentCopyOutlined, {});
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Tooltip,
      {
        title: copyTooltipText,
        leaveDelay: 0,
        placement: tooltipPlacement,
        ...tooltipProps,
        children: /* @__PURE__ */ jsxs(
          Box,
          {
            ...props,
            sx: { cursor: disabled ? void 0 : "pointer" },
            onClick: handleClick,
            "data-name": "copiable",
            ref,
            children: [
              children,
              button && /* @__PURE__ */ jsx(
                IconButton,
                {
                  ...buttonProps,
                  disabled,
                  icon: copyIcon,
                  "data-testid": dataTestId,
                  "aria-label": ariaLabel || buttonLabel || (copyTooltipText ?? ""),
                  sx: {
                    display: "flex"
                  }
                }
              )
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      Snackbar,
      {
        autoWidth: true,
        closeable: false,
        autoHideDuration: 4e3,
        ...snackbarProps,
        open,
        onClose: () => setOpen(false),
        children: copySuccessMessage
      }
    )
  ] });
};
const CopiableComponent = forwardRef(_CopiableComponent);
const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => !["isInputFocused"].includes(prop)
})(({ isInputFocused }) => ({
  "& input": {
    pointerEvents: isInputFocused ? "auto" : "none"
    // Disable pointer events when not focused https://issues.chromium.org/issues/41245282
  }
}));
const AdornmentWrapper = styled(Box, {
  shouldForwardProp: (prop) => !["size", "variant"].includes(prop)
})(({ variant, size, theme }) => ({
  width: theme.spacing(3),
  ...variant === "standard" ? {
    marginLeft: theme.spacing(-0.25)
  } : {
    marginRight: theme.spacing(-1)
  },
  ...size === "medium" && {
    width: theme.spacing(4),
    ...variant === "standard" ? {
      marginLeft: theme.spacing(-0.5)
    } : {
      marginLeft: theme.spacing(1)
    }
  }
}));
function _CopiableInputText({
  value,
  variant,
  InputProps,
  extraEndAdornment,
  onCopied,
  password,
  size = "small",
  onFocus,
  onBlur,
  showText: showTextProp,
  hideText: hideTextProp,
  ...rest
}, ref) {
  const [showPassword, setShowPassword] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const inputType = !password ? "text" : showPassword ? "text" : "password";
  const showTextLabel = useTranslationWithFallback(
    "c4r.button.show",
    showTextProp
  );
  const hideTextLabel = useTranslationWithFallback(
    "c4r.button.hide",
    hideTextProp
  );
  const currentLabel = showPassword ? hideTextLabel : showTextLabel;
  const handleFocus = (event) => {
    setIsInputFocused(true);
    onFocus == null ? void 0 : onFocus(event);
  };
  const handleBlur = (event) => {
    setIsInputFocused(false);
    onBlur == null ? void 0 : onBlur(event);
  };
  const passwordAdornment = /* @__PURE__ */ jsx(InputAdornment, { position: "end", children: /* @__PURE__ */ jsx(
    IconButton,
    {
      edge: variant !== "standard" ? "end" : void 0,
      onClick: () => setShowPassword(!showPassword),
      size,
      icon: showPassword ? /* @__PURE__ */ jsx(VisibilityOutlined, {}) : /* @__PURE__ */ jsx(VisibilityOffOutlined, {}),
      tooltip: currentLabel,
      "aria-label": currentLabel
    }
  ) });
  return /* @__PURE__ */ jsx(
    StyledTextField,
    {
      ...rest,
      isInputFocused,
      size,
      value,
      variant,
      InputProps: {
        readOnly: true,
        onFocus: handleFocus,
        onBlur: handleBlur,
        endAdornment: /* @__PURE__ */ jsxs(Fragment, { children: [
          password ? passwordAdornment : extraEndAdornment,
          /* @__PURE__ */ jsx(InputAdornment, { position: "end", children: /* @__PURE__ */ jsx(AdornmentWrapper, { size, variant, children: /* @__PURE__ */ jsx(
            CopiableComponent,
            {
              value,
              onCopied,
              button: true,
              buttonProps: {
                size
              }
            }
          ) }) })
        ] }),
        ...variant === "filled" && {
          disableUnderline: true
        },
        ...InputProps
      },
      type: inputType,
      "data-name": "copiable-input-text",
      ref
    }
  );
}
const CopiableInputText = forwardRef(_CopiableInputText);
const AUTOCOMPLETE_GROUP_HEADER_PROPERTY = "__isGroupHeader";
function isAutocompleteListGroupHeader(option) {
  return typeof option === "object" && option !== null && AUTOCOMPLETE_GROUP_HEADER_PROPERTY in option;
}
const getDefaultOptionLabel = (option) => {
  return option && typeof option === "object" ? option.title ?? String(option) : String(option);
};
const createOptionWithMultiple = (option, multiple) => {
  return typeof option !== "object" || option === null ? { value: option, multiple } : { ...option, multiple };
};
const getDefaultLimitTagsText = (more) => /* @__PURE__ */ jsxs("span", { "data-testid": "more-options-tag", children: [
  "+",
  more
] });
function createCounterRenderTags({
  formatCounter,
  options = [],
  size = "small",
  getOptionLabel = getDefaultOptionLabel
}) {
  const CounterRenderTags = (value) => {
    if (value.length === 0) {
      return null;
    }
    const selectedCount = value.length;
    const selectableOptions = options.filter(
      (option) => !isAutocompleteListGroupHeader(option)
    );
    const totalCount = selectableOptions.length;
    const text = formatCounter({
      selectedCount,
      totalCount,
      selectedItems: value,
      allItems: selectableOptions,
      getOptionLabel
    });
    return /* @__PURE__ */ jsx(
      Typography,
      {
        variant: size === "small" ? "body2" : "body1",
        component: "span",
        "data-testid": "counter-tag",
        sx: {
          ml: 1
        },
        children: text
      }
    );
  };
  return CounterRenderTags;
}
function createCounterFormatter({
  counterText,
  allText,
  showSingleItemText = true
}) {
  return ({
    selectedCount,
    totalCount,
    selectedItems,
    getOptionLabel
  }) => {
    if (selectedCount === totalCount && totalCount > 0) {
      return allText;
    } else if (selectedCount === 1 && showSingleItemText) {
      return getOptionLabel(selectedItems[0]);
    } else {
      return `${selectedCount} ${counterText}`;
    }
  };
}
function createAutocompleteGroupByList({
  options,
  groupBy,
  extended
}) {
  const grouped = options.reduce(
    (acc, option) => {
      const group = groupBy(option);
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(option);
      return acc;
    },
    {}
  );
  const result = [];
  Object.keys(grouped).forEach((title) => {
    result.push({ [AUTOCOMPLETE_GROUP_HEADER_PROPERTY]: true, title, extended });
    const groupOptions = grouped[title];
    if (groupOptions) {
      result.push(...groupOptions);
    }
  });
  return result;
}
const warnDeprecatedGroupBy = /* @__PURE__ */ (() => {
  const shownWarnings = /* @__PURE__ */ new Set();
  return (componentName) => {
    if (process.env.NODE_ENV !== "production" && !shownWarnings.has(componentName)) {
      shownWarnings.add(componentName);
      console.warn(
        `${componentName}: The \`groupBy\` prop is deprecated because it breaks virtualization. Use \`createAutocompleteGroupByList\` instead.`
      );
    }
  };
})();
function _Autocomplete({
  disabled,
  loading,
  ...props
}, ref) {
  if (props.groupBy) {
    warnDeprecatedGroupBy("Autocomplete");
  }
  return /* @__PURE__ */ jsx(
    Autocomplete$1,
    {
      ...props,
      ref,
      disabled: disabled || loading,
      popupIcon: loading ? /* @__PURE__ */ jsx(CircularProgress$1, { size: 18, color: "inherit" }) : /* @__PURE__ */ jsx(ArrowDown, {}),
      "data-name": "autocomplete",
      ListboxProps: {
        "aria-multiselectable": false,
        ...props.ListboxProps
      }
    }
  );
}
const Autocomplete = forwardRef(_Autocomplete);
function useAutocompleteRenderOption() {
  const renderOption = (props, option, state, getOptionLabel, customIcon) => {
    const { key, ...otherProps } = props;
    if (isAutocompleteListGroupHeader(option)) {
      return /* @__PURE__ */ createElement(
        MenuItem$1,
        {
          ...otherProps,
          subtitle: true,
          extended: option.extended,
          key,
          "aria-disabled": true,
          "aria-selected": false
        },
        option.title
      );
    }
    const regularOption = option;
    const {
      title,
      inputValue,
      divider,
      fixed,
      extended,
      dense,
      destructive,
      disabled,
      subtitle,
      iconColor,
      startAdornment,
      endAdornment,
      alternativeTitle,
      secondaryText,
      multiple
    } = regularOption;
    const isPrimitiveOptionType = typeof regularOption === "string" || typeof regularOption === "number";
    const getOptionLabelText = (getOptionLabel2, option2, alternativeTitle2, title2) => {
      if (alternativeTitle2) return alternativeTitle2;
      if (title2) return title2;
      if (option2 && typeof option2 === "object" && "value" in option2) {
        return String(option2.value);
      }
      return getOptionLabel2(option2);
    };
    return /* @__PURE__ */ jsx(Fragment$1, { children: divider ? /* @__PURE__ */ jsx(Divider, {}) : /* @__PURE__ */ jsxs(Fragment, { children: [
      inputValue && /* @__PURE__ */ jsx(Divider, {}),
      /* @__PURE__ */ jsxs(
        MenuItem$1,
        {
          ...otherProps,
          ...!isPrimitiveOptionType && {
            fixed,
            extended,
            dense,
            destructive,
            disabled,
            subtitle,
            iconColor
          },
          ...{ "aria-disabled": subtitle || disabled },
          ...{ "aria-selected": state.selected },
          children: [
            !subtitle && (startAdornment || multiple || customIcon) && /* @__PURE__ */ jsxs(ListItemIcon, { children: [
              customIcon || multiple && /* @__PURE__ */ jsx(Checkbox, { checked: state.selected }),
              startAdornment
            ] }),
            /* @__PURE__ */ jsxs(ListItemText, { children: [
              getOptionLabelText(
                getOptionLabel ?? getDefaultOptionLabel,
                regularOption,
                alternativeTitle,
                title
              ),
              secondaryText && /* @__PURE__ */ jsx(
                Typography,
                {
                  component: "p",
                  variant: "caption",
                  color: "text.secondary",
                  children: secondaryText
                }
              )
            ] }),
            !subtitle && endAdornment
          ]
        }
      )
    ] }) }, key);
  };
  return { renderOption };
}
function useCreatableAutocomplete({
  getOptionLabel,
  newItemLabel,
  newItemIcon,
  multiple
}) {
  const filter = createFilterOptions();
  const { renderOption: autocompleteRenderOption } = useAutocompleteRenderOption();
  const addLabel = useTranslationWithFallback(
    "c4r.form.add",
    typeof newItemLabel === "string" ? newItemLabel : void 0
  );
  const creatableFilterOptions = (options, params) => {
    const filtered = filter(
      options,
      params
    );
    const { inputValue } = params;
    const isExisting = options.some(
      (option) => inputValue === getOptionLabel(option)
    );
    if (inputValue.length > 1 && inputValue !== "" && !isExisting) {
      let newItemText;
      if (typeof newItemLabel === "function") {
        newItemText = newItemLabel(inputValue);
      } else {
        newItemText = `${addLabel} "${inputValue}"`;
      }
      filtered.push({
        inputValue,
        title: newItemText
      });
    }
    return filtered;
  };
  const creatableOptionLabel = (option) => {
    if (typeof option === "string") {
      return option;
    }
    if (option.inputValue) {
      return option.inputValue;
    }
    return getOptionLabel(option);
  };
  const creatableRenderOption = (props, option, state) => {
    const customIcon = option.inputValue ? newItemIcon ?? /* @__PURE__ */ jsx(AddCircleOutlineOutlined, {}) : void 0;
    const optionWithMultiple = createOptionWithMultiple(option, !!multiple);
    return autocompleteRenderOption(
      props,
      optionWithMultiple,
      state,
      getOptionLabel,
      customIcon
    );
  };
  return {
    creatableFilterOptions,
    creatableOptionLabel,
    creatableRenderOption
  };
}
function useMultipleAutocomplete({
  options,
  value,
  onChange,
  getOptionLabel,
  size,
  counterFormatter,
  counterText,
  allSelectedText
}) {
  const [multipleValue, setMultipleValue] = useState(
    Array.isArray(value) ? value : value ? [value] : []
  );
  const { renderOption: autocompleteRenderOption } = useAutocompleteRenderOption();
  const defaultCounterText = useTranslationWithFallback(
    "c4r.form.selected",
    counterText
  );
  const defaultAllSelectedText = useTranslationWithFallback(
    "c4r.form.allSelected",
    allSelectedText
  );
  useEffect(() => {
    const newValue = Array.isArray(value) ? value : value ? [value] : [];
    setMultipleValue(newValue);
  }, [value]);
  const selectableOptions = options.filter(
    (option) => !isAutocompleteListGroupHeader(option)
  );
  const allSelected = multipleValue.length === selectableOptions.length;
  const someSelected = multipleValue.length > 0 && multipleValue.length < selectableOptions.length;
  const handleSelectAll = (event) => {
    const newValue = allSelected ? [] : [...selectableOptions];
    setMultipleValue(newValue);
    onChange == null ? void 0 : onChange(
      event,
      newValue,
      "selectOption"
    );
  };
  const handleChange = (event, newValue, reason) => {
    const multipleNewValue = newValue === null ? [] : newValue;
    setMultipleValue(multipleNewValue);
    onChange == null ? void 0 : onChange(event, newValue, reason);
  };
  const multipleRenderOption = (props, option, state) => {
    const optionWithMultiple = createOptionWithMultiple(option, true);
    return autocompleteRenderOption(
      props,
      optionWithMultiple,
      state,
      getOptionLabel
    );
  };
  const getCounterRenderTags = useCallback(() => {
    const formatter = counterFormatter || createCounterFormatter({
      counterText: defaultCounterText,
      allText: defaultAllSelectedText
    });
    return createCounterRenderTags({
      formatCounter: formatter,
      options,
      size,
      getOptionLabel: getOptionLabel ? (option) => getOptionLabel(option) : void 0
    });
  }, [
    options,
    counterFormatter,
    defaultCounterText,
    defaultAllSelectedText,
    size,
    getOptionLabel
  ]);
  return {
    multipleValue,
    allSelected,
    someSelected,
    handleSelectAll,
    handleChange,
    multipleRenderOption,
    getCounterRenderTags
  };
}
const List = styled("ul")(
  ({ theme, hasFilters }) => ({
    ...!hasFilters && {
      paddingTop: `${theme.spacing(1)} !important`
    }
  })
);
const ItemWrapper = styled("div")(({ style, theme, isSubtitle, isExtended, isMultiple }) => {
  const getSubtitleStyles = () => {
    const baseStyles = {
      height: MENU_ITEM_SIZE_DENSE,
      minHeight: MENU_ITEM_SIZE_DENSE,
      marginTop: `${theme.spacing(1)} !important`,
      alignItems: "flex-end",
      ...theme.typography.caption,
      fontWeight: 500
    };
    if (isExtended) {
      baseStyles.alignItems = "center";
      if (isMultiple) {
        baseStyles.marginLeft = theme.spacing(0.5);
      }
    }
    return baseStyles;
  };
  return {
    pointerEvents: "none",
    // To avoid the extra div to receive the click event
    "& .MuiMenuItem-root": {
      pointerEvents: "auto",
      // Allow pointer events for the menu item
      marginTop: 0,
      "&:first-of-type": {
        marginTop: "0 !important"
      }
    },
    ...isSubtitle && {
      "& .MuiAutocomplete-option.MuiMenuItem-root": getSubtitleStyles(),
      // First item has no divider
      "&:not(:first-of-type)": {
        "&::before": {
          content: '""',
          position: "absolute",
          zIndex: 1,
          top: theme.spacing(0.5),
          left: 0,
          right: 0,
          height: "1px",
          backgroundColor: theme.palette.divider
        }
      }
    },
    ...!isSubtitle && {
      "& .MuiAutocomplete-option": {
        minHeight: `${style == null ? void 0 : style.height}px !important`
      }
    }
  };
});
function _AutocompleteList({
  children,
  showFilters,
  allSelected,
  someSelected,
  handleSelectAll = () => void 0,
  multiple,
  extended,
  itemHeight,
  maxListHeight = MENU_LIST_MAX_SIZE,
  selectAllText,
  ...otherProps
}, ref) {
  const childrenArray = useMemo(() => {
    return React.Children.toArray(children).map((child) => {
      if (!React.isValidElement(child)) {
        return {
          child,
          isSubtitle: false,
          isExtended: false,
          isMultiple: !!multiple
        };
      }
      const props = child.props;
      return {
        child,
        isSubtitle: props.subtitle === true,
        isExtended: props.extended === true,
        isMultiple: !!multiple
      };
    });
  }, [children, multiple]);
  const defaultItemHeight = itemHeight ?? (extended ? MENU_ITEM_SIZE_EXTENDED : MENU_ITEM_SIZE_DEFAULT);
  const listboxHeight = useMemo(() => {
    const filterHeight = showFilters && multiple ? MENU_ITEM_SIZE_EXTENDED : 0;
    const availableHeight = maxListHeight - filterHeight;
    const calculatedHeight = Math.min(
      childrenArray.length * defaultItemHeight,
      availableHeight
    );
    return Math.max(calculatedHeight, defaultItemHeight);
  }, [
    showFilters,
    multiple,
    maxListHeight,
    childrenArray.length,
    defaultItemHeight
  ]);
  const renderItem = ({
    index,
    style
  }) => {
    const item = childrenArray[index];
    if (!item) return null;
    const { child, isSubtitle, isExtended, isMultiple } = item;
    return /* @__PURE__ */ jsx(
      ItemWrapper,
      {
        style,
        isSubtitle,
        isExtended,
        isMultiple,
        "data-name": "virtual-menu-item",
        children: child
      }
    );
  };
  return /* @__PURE__ */ jsxs(
    List,
    {
      ref,
      ...otherProps,
      role: "listbox",
      "data-list-height": listboxHeight,
      "data-item-height": defaultItemHeight,
      "aria-multiselectable": multiple,
      hasFilters: showFilters,
      style: {
        maxHeight: maxListHeight + defaultItemHeight
      },
      children: [
        showFilters && multiple && /* @__PURE__ */ jsx(
          MenuItemFilter,
          {
            areAllSelected: !!allSelected,
            areAnySelected: !!someSelected,
            selectAll: handleSelectAll,
            selectAllText
          }
        ),
        /* @__PURE__ */ jsx(
          FixedSizeList,
          {
            height: listboxHeight,
            width: "100%",
            itemCount: childrenArray.length,
            itemSize: defaultItemHeight,
            children: renderItem
          }
        )
      ]
    }
  );
}
const AutocompleteList = forwardRef(_AutocompleteList);
function _CreatableAutocomplete({
  newItemLabel,
  newItemIcon,
  getOptionLabel = getDefaultOptionLabel,
  multiple,
  disableCloseOnSelect,
  disabled,
  loading,
  showFilters,
  showCounter = false,
  counterFormatter,
  counterText,
  allSelectedText,
  selectAllText,
  options = [],
  value,
  onChange,
  getLimitTagsText,
  renderTags,
  itemHeight,
  maxListHeight,
  extended,
  groupBy,
  ...props
}, ref) {
  if (groupBy) {
    warnDeprecatedGroupBy("CreatableAutocomplete");
  }
  const { freeSolo = true, ...otherProps } = props;
  const {
    multipleValue,
    allSelected,
    someSelected,
    handleSelectAll,
    handleChange,
    getCounterRenderTags
  } = useMultipleAutocomplete({
    options,
    value,
    onChange,
    getOptionLabel,
    size: props.size,
    counterFormatter,
    counterText,
    allSelectedText
  });
  const {
    creatableFilterOptions,
    creatableOptionLabel,
    creatableRenderOption
  } = useCreatableAutocomplete({
    getOptionLabel,
    newItemLabel,
    newItemIcon,
    multiple
  });
  const listboxProps = {
    showFilters,
    allSelected,
    someSelected,
    handleSelectAll,
    multiple,
    itemHeight,
    maxListHeight,
    extended,
    selectAllText
  };
  const finalRenderTags = showCounter && multiple && !renderTags ? getCounterRenderTags() : renderTags;
  return /* @__PURE__ */ jsx(
    Autocomplete$1,
    {
      ...otherProps,
      ref,
      options,
      value: multiple ? multipleValue : value,
      onChange: handleChange,
      filterOptions: creatableFilterOptions,
      getOptionLabel: creatableOptionLabel,
      renderOption: creatableRenderOption,
      renderTags: finalRenderTags,
      freeSolo,
      forcePopupIcon: true,
      multiple,
      disableCloseOnSelect: disableCloseOnSelect ?? multiple,
      ListboxComponent: AutocompleteList,
      ListboxProps: listboxProps,
      getLimitTagsText: getLimitTagsText ?? getDefaultLimitTagsText,
      disabled: disabled || loading,
      popupIcon: loading ? /* @__PURE__ */ jsx(CircularProgress$1, { size: 18, color: "inherit" }) : /* @__PURE__ */ jsx(ArrowDown, {}),
      "data-name": "creatable-autocomplete"
    }
  );
}
const CreatableAutocomplete = forwardRef(_CreatableAutocomplete);
function _MultipleAutocomplete({
  renderOption,
  disableCloseOnSelect = true,
  disabled,
  loading,
  showFilters,
  showCounter = false,
  counterFormatter,
  counterText,
  allSelectedText,
  selectAllText,
  options,
  value,
  onChange,
  getOptionLabel,
  getLimitTagsText,
  renderTags,
  itemHeight,
  maxListHeight,
  extended,
  groupBy,
  ...props
}, ref) {
  if (groupBy) {
    warnDeprecatedGroupBy("MultipleAutocomplete");
  }
  const {
    multipleValue,
    allSelected,
    someSelected,
    handleSelectAll,
    handleChange,
    multipleRenderOption,
    getCounterRenderTags
  } = useMultipleAutocomplete({
    options,
    value,
    onChange,
    getOptionLabel,
    size: props.size,
    counterFormatter,
    counterText,
    allSelectedText
  });
  const listboxProps = {
    showFilters,
    allSelected,
    someSelected,
    handleSelectAll,
    multiple: true,
    itemHeight,
    maxListHeight,
    extended,
    selectAllText
  };
  const finalRenderTags = showCounter && !renderTags ? getCounterRenderTags() : renderTags;
  return /* @__PURE__ */ jsx(
    Autocomplete$1,
    {
      ...props,
      ref,
      options,
      value: multipleValue,
      onChange: handleChange,
      getOptionLabel,
      renderOption: renderOption ?? multipleRenderOption,
      renderTags: finalRenderTags,
      ListboxComponent: AutocompleteList,
      ListboxProps: listboxProps,
      multiple: true,
      getLimitTagsText: getLimitTagsText ?? getDefaultLimitTagsText,
      disableCloseOnSelect,
      disabled: disabled || loading,
      popupIcon: loading ? /* @__PURE__ */ jsx(CircularProgress$1, { size: 18, color: "inherit" }) : /* @__PURE__ */ jsx(ArrowDown, {}),
      "data-name": "multiple-autocomplete"
    }
  );
}
const MultipleAutocomplete = forwardRef(_MultipleAutocomplete);
function useAutocomplete({
  getOptionLabel = getDefaultOptionLabel
}) {
  const { renderOption: autocompleteRenderOption } = useAutocompleteRenderOption();
  const internalGetOptionLabel = (option) => {
    if (isAutocompleteListGroupHeader(option)) {
      return option.title;
    }
    return getOptionLabel(option);
  };
  const singleRenderOption = (props, option, state) => {
    const optionWithMultiple = createOptionWithMultiple(option, false);
    return autocompleteRenderOption(
      props,
      optionWithMultiple,
      state,
      internalGetOptionLabel
    );
  };
  return {
    singleRenderOption,
    getOptionLabel: internalGetOptionLabel
  };
}
const Menu$1 = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  height: APPBAR_SIZE,
  marginRight: theme.spacing(1.5)
}));
const MenuButton = styled(IconButton$1)(({ theme }) => ({
  marginRight: theme.spacing(1),
  "&.MuiButtonBase-root svg path": {
    fill: theme.palette.brand.appBarContrastText
  }
}));
const MenuDivider = styled(Divider)(({ theme }) => ({
  borderColor: alpha(theme.palette.brand.appBarContrastText, 0.12)
}));
function BurgerMenu({
  onClickMenu
}) {
  return (
    // replacing deprecated `<Hidden />` with sx following this MUI5 guide:
    // https://mui.com/material-ui/migration/v5-component-changes/#hidden
    /* @__PURE__ */ jsx(
      Box,
      {
        sx: {
          display: { md: "none", xs: "block" }
        },
        children: /* @__PURE__ */ jsxs(Menu$1, { children: [
          /* @__PURE__ */ jsx(MenuButton, { onClick: onClickMenu, children: /* @__PURE__ */ jsx(MenuOutlined, {}) }),
          /* @__PURE__ */ jsx(MenuDivider, { orientation: "vertical", flexItem: true })
        ] })
      }
    )
  );
}
const Logo = styled("div")(({ theme }) => ({
  display: "flex",
  marginRight: theme.spacing(1.5),
  "& a": {
    display: "flex"
  },
  "& svg, & img": {
    width: theme.spacing(4),
    height: theme.spacing(4)
  }
}));
function BrandLogo({ logo }) {
  return /* @__PURE__ */ jsx(Logo, { children: logo });
}
const Text$1 = styled(Typography)({
  display: "flex",
  alignItems: "center",
  whiteSpace: "nowrap"
});
function BrandText({ text }) {
  const theme = useTheme();
  return /* @__PURE__ */ jsx(
    Text$1,
    {
      component: "span",
      variant: "subtitle1",
      color: theme.palette.brand.appBarContrastText,
      children: text
    }
  );
}
const Text = styled(Typography)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  "&::before": {
    content: '"/"',
    margin: theme.spacing(0, 1),
    opacity: 0.6,
    color: theme.palette.brand.appBarContrastText
  }
}));
function SecondaryText({ text }) {
  const theme = useTheme();
  return /* @__PURE__ */ jsx(
    Text,
    {
      component: "span",
      variant: "body2",
      weight: "strong",
      color: theme.palette.brand.appBarContrastText,
      children: text
    }
  );
}
const Root$4 = styled(AppBar$1)(({ theme }) => ({
  backgroundColor: theme.palette.brand.appBarMain,
  userSelect: "none",
  "& .MuiTypography-root": {
    color: theme.palette.brand.appBarContrastText
  },
  "& .MuiIconButton-root path": {
    fill: theme.palette.brand.appBarContrastText
  }
}));
const BrandElements = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  maxWidth: "calc(100% - 300px)",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    minWidth: "192px"
  }
}));
const Content$5 = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flex: 1,
  marginLeft: theme.spacing(1)
}));
function _AppBar({
  children,
  brandLogo,
  brandText,
  secondaryText,
  showBurgerMenu = false,
  onClickMenu,
  ...otherProps
}, ref) {
  return /* @__PURE__ */ jsx(Root$4, { ...otherProps, ref, "data-name": "app-bar", children: /* @__PURE__ */ jsxs(Toolbar, { children: [
    /* @__PURE__ */ jsxs(BrandElements, { children: [
      showBurgerMenu && /* @__PURE__ */ jsx(BurgerMenu, { onClickMenu }),
      brandLogo && /* @__PURE__ */ jsx(BrandLogo, { logo: brandLogo }),
      brandText && /* @__PURE__ */ jsx(BrandText, { text: brandText }),
      secondaryText && /* @__PURE__ */ jsx(SecondaryText, { text: secondaryText })
    ] }),
    /* @__PURE__ */ jsx(Content$5, { children })
  ] }) });
}
const AppBar = forwardRef(_AppBar);
const Footer = styled(Box, {
  shouldForwardProp: (prop) => !["withGutter", "disabled"].includes(prop)
})(
  ({ withGutter, disabled, theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    ...withGutter && {
      height: theme.spacing(4),
      padding: theme.spacing(0, 0.5),
      borderTop: `1px solid ${theme.palette.divider}`,
      borderBottom: "1px solid transparent"
    },
    ...disabled && {
      backgroundColor: theme.palette.default.background
    }
  })
);
function CodeAreaFooter({
  onClickFooter,
  buttonFooterLabelId,
  buttonFooterText,
  disabledButtonFooter,
  withGutter = true,
  showSnackbar,
  onCloseSnackbar,
  loading,
  disabled,
  changesSavedText,
  ...props
}) {
  const buttonFooterLabel = useTranslationWithFallback(
    buttonFooterLabelId || "c4r.button.save",
    buttonFooterText
  );
  const changesSavedLabel = useTranslationWithFallback(
    "c4r.notifications.changesSaved",
    changesSavedText
  );
  if (!onClickFooter) return null;
  return /* @__PURE__ */ jsxs(
    Footer,
    {
      withGutter,
      disabled,
      "data-name": "code-area-footer",
      "data-gutter": withGutter,
      children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: "text",
            ...props,
            loading,
            onClick: onClickFooter,
            disabled: disabled || disabledButtonFooter,
            children: buttonFooterLabel
          }
        ),
        /* @__PURE__ */ jsx(
          Snackbar,
          {
            open: showSnackbar,
            autoWidth: true,
            closeable: false,
            autoHideDuration: 4e3,
            onClose: onCloseSnackbar,
            children: changesSavedLabel
          }
        )
      ]
    }
  );
}
const Header = styled(Box, { shouldForwardProp: (prop) => prop !== "size" })(({ size, theme }) => ({
  position: "absolute",
  top: 0,
  right: theme.spacing(0.5),
  zIndex: 1,
  display: "flex",
  justifyContent: "flex-end",
  gap: theme.spacing(1),
  padding: size === "small" ? theme.spacing(0.5) : theme.spacing(1, 2, 2),
  paddingRight: size === "small" ? 0 : theme.spacing(1.5)
}));
function CodeAreaHeader({
  disabled,
  copyValue,
  onClickExpand,
  size,
  showOptionsTooltipText,
  copyText,
  expandText,
  copiedText
}) {
  const showExpandButton = !!onClickExpand;
  const showCopyButton = copyValue !== void 0;
  const showMenu = showExpandButton && showCopyButton;
  const { copy } = useCopyValue();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const showOptionsTooltipLabel = useTranslationWithFallback(
    "c4r.button.showOptions",
    showOptionsTooltipText
  );
  const copyLabel = useTranslationWithFallback("c4r.button.copy", copyText);
  const expandLabel = useTranslationWithFallback(
    "c4r.button.expand",
    expandText
  );
  const copiedLabel = useTranslationWithFallback(
    "c4r.notifications.copiedToClipboard",
    copiedText
  );
  const openDropdown = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const closeDropdown = () => {
    setAnchorEl(null);
  };
  const handleCopy = (e) => {
    e.preventDefault();
    if (copyValue) {
      copy(copyValue).then(() => {
        setOpenSnackbar(true);
      }).catch(console.error);
    }
  };
  if (!showExpandButton && !showCopyButton) {
    return null;
  }
  if (showMenu) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(Header, { size, "data-size": size, "data-name": "code-area-header", children: [
        /* @__PURE__ */ jsx(
          IconButton,
          {
            color: "default",
            size,
            icon: /* @__PURE__ */ jsx(MoreVertOutlined, {}),
            disabled,
            tooltip: showOptionsTooltipLabel,
            tooltipPlacement: "top",
            "aria-controls": open ? "basic-menu" : void 0,
            "aria-haspopup": "true",
            "aria-expanded": open ? "true" : void 0,
            onClick: openDropdown
          }
        ),
        /* @__PURE__ */ jsxs(
          Menu,
          {
            anchorEl,
            open,
            onClose: closeDropdown,
            id: "menu",
            MenuListProps: { "aria-labelledby": "menu-button" },
            "aria-label": "Code area actions",
            transformOrigin: { vertical: "top", horizontal: "right" },
            anchorOrigin: { vertical: "bottom", horizontal: "right" },
            children: [
              /* @__PURE__ */ jsxs(MenuItem$1, { onClick: handleCopy, disabled, id: "copy", children: [
                /* @__PURE__ */ jsx(ListItemIcon, { children: /* @__PURE__ */ jsx(ContentCopyOutlined, {}) }),
                /* @__PURE__ */ jsx(ListItemText, { children: copyLabel })
              ] }),
              /* @__PURE__ */ jsxs(MenuItem$1, { onClick: onClickExpand, disabled, id: "expand", children: [
                /* @__PURE__ */ jsx(ListItemIcon, { children: /* @__PURE__ */ jsx(OpenDiagonallyRight, {}) }),
                /* @__PURE__ */ jsx(ListItemText, { children: expandLabel })
              ] })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsx(
        Snackbar,
        {
          open: openSnackbar,
          autoWidth: true,
          closeable: false,
          autoHideDuration: 4e3,
          onClose: () => setOpenSnackbar(false),
          children: copiedLabel
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxs(Header, { size, "data-size": size, "data-name": "code-area-header", children: [
    showCopyButton && /* @__PURE__ */ jsx(
      CopiableComponent,
      {
        disabled,
        value: copyValue,
        button: true,
        buttonProps: { size },
        copyText,
        copiedText
      }
    ),
    showExpandButton && /* @__PURE__ */ jsx(
      IconButton,
      {
        color: "default",
        size,
        onClick: onClickExpand,
        icon: /* @__PURE__ */ jsx(OpenDiagonallyRight, {}),
        disabled,
        tooltip: expandLabel,
        tooltipPlacement: "top"
      }
    )
  ] });
}
const CodeAreaTheme = styled(Box, {
  shouldForwardProp: (prop) => !["size", "height"].includes(prop)
})(({ size, height, theme }) => ({
  position: "relative",
  flex: 1,
  display: "flex",
  cursor: "text",
  ":focus-within &, .error &": {
    marginBottom: 0
  },
  "& .react-codemirror2": {
    width: "100%",
    height: "100% !important",
    position: "relative"
  },
  "& .CodeMirror": {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    height: "100% !important",
    backgroundColor: theme.palette.background.default
  },
  "& .CodeMirror-code": {
    "&> div:first-of-type .CodeMirror-line": {
      marginTop: theme.spacing(-0.25)
    }
  },
  "& .CodeMirror-scroll": {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    backgroundColor: "transparent"
  },
  "& .CodeMirror-lines": {
    padding: theme.spacing(1, 0)
  },
  "& .CodeMirror pre.CodeMirror-line, & .CodeMirror pre.CodeMirror-line-like": {
    boxSizing: "border-box",
    paddingLeft: 0,
    paddingTop: theme.spacing(0.25),
    lineHeight: 1.2
  },
  "& .CodeMirror-linenumbers": {
    width: `${theme.spacing(4.5)} !important`
  },
  "& .CodeMirror-linenumber": {
    width: `${theme.spacing(4.5)} !important`,
    height: theme.spacing(2),
    marginBottom: `${theme.spacing(-0.25)} !important`,
    paddingTop: theme.spacing(0.25),
    paddingRight: theme.spacing(1.25),
    boxSizing: "border-box !important",
    color: theme.palette.text.secondary
  },
  // Active line addon
  "& .CodeMirror-activeline-background, & .CodeMirror-activeline-gutter": {
    backgroundColor: "transparent"
  },
  "& .CodeMirror-gutter-background": {
    width: `${theme.spacing(6.25)} !important`
    // Hack needed to simulate active line background
  },
  "& .CodeMirror-sizer": {
    paddingTop: theme.spacing(0.25),
    marginLeft: `${theme.spacing(5.25)} !important`,
    borderRightWidth: `${theme.spacing(4)} !important`
    // Hack needed to simulate active line background
  },
  "& .CodeMirror-matchingbracket": {
    color: `${lime[900]} !important`,
    backgroundColor: theme.palette.black[4],
    boxShadow: `0 0 0 1px ${theme.palette.text.hint}`
  },
  // Selected line
  "& .CodeMirror-selected, & .CodeMirror-focused .CodeMirror-selected, & .CodeMirror-line::selection, & .CodeMirror-line > span::selection, & .CodeMirror-line > span > span::selection": {
    background: `${alpha(blue[800], 0.2)} !important`
  },
  "& .CodeMirror-gutters": {
    borderRight: 0,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.default.background
  },
  "& .CodeMirror-gutter-elt": {
    "& .CodeMirror-foldgutter-open, .CodeMirror-foldgutter-folded": {
      marginLeft: theme.spacing(-1),
      "&:after": {
        fontSize: theme.typography.caption.fontSize
      }
    }
  },
  "& .CodeMirror-placeholder": {
    paddingTop: "0 !important",
    marginLeft: `${theme.spacing(-0.5)} !important`,
    marginBottom: `${theme.spacing(-0.25)} !important`,
    color: `${theme.palette.text.hint} !important`
  },
  "& .MuiLinearProgress-root": {
    height: "2px",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1
  },
  ".CodeMirror pre.CodeMirror-line, .CodeMirror pre.CodeMirror-line-like, & .cm-bracket": {
    color: theme.palette.text.primary,
    fontVariantLigatures: "no-common-ligatures"
  },
  "& .CodeMirror pre.CodeMirror-placeholder": {
    color: theme.palette.text.hint
  },
  "& .CodeMirror-composing": {
    border: 0
  },
  // Theme: light
  "& .cm-keyword, & .cm-string, & .cm-string-2, & .cm-other": {
    color: purple[500]
  },
  "& .cm-operator, & .cm-tag, & .cm-attribute": {
    color: teal[700]
  },
  "& .cm-number, & .cm-property, & .cm-builtin": {
    color: red[700]
  },
  "& .cm-comment, & .cm-quote": {
    color: theme.palette.text.secondary
  },
  "& .cm-variable": {
    color: lime[900]
  },
  "& .cm-variable-2": {
    color: theme.palette.text.primary
  },
  "& .cm-punctuation, & .cm-def": {
    color: blue[800]
  },
  "& .cm-image-alt-text, & .cm-link": {
    color: green[800],
    textDecoration: "none"
  },
  // Custom inline link styling .cm-inline-url
  "& .cm-url, & .cm-inline-url": {
    color: blue[800],
    textDecoration: "none"
  },
  "& .cm-variable-3, & .cm-type": {
    color: indigo[800]
  },
  "& .CodeMirror-foldmarker": {
    textShadow: "none",
    color: theme.palette.primary.main
  },
  "& .cm-error": {
    color: theme.palette.error.main
  },
  "& .CodeMirror-selected": {
    background: blue[800]
  },
  "& .cm-header": {
    color: red[700],
    ...theme.typography.code3,
    fontWeight: theme.typography.fontWeightBold
  },
  "& .cm-header-4, & .cm-header-5, & .cm-header-6": {
    fontWeight: theme.typography.fontWeightRegular
  },
  // Custom inline code styling
  "& .cm-inline-code": {
    backgroundColor: theme.palette.black[4],
    color: purple[500]
  },
  // Custom code block styling
  "& .cm-code-block": {
    backgroundColor: theme.palette.black[4],
    marginRight: theme.spacing(2)
  },
  ...size === "small" && {
    "& .CodeMirror": {
      height: height ? height : "auto",
      minHeight: theme.spacing(9),
      ...theme.typography.code3
    }
  }
}));
function findCodeAreaControlCodeOccurrences(content) {
  const lines = content.split("\n");
  const matches = [];
  const beginStack = [];
  lines.forEach((line, index) => {
    const lineNumber = index + 1;
    if (line.trim() === "-- BEGIN CONTROL CODE") {
      beginStack.push(lineNumber);
    } else if (line.trim() === "-- END CONTROL CODE" && beginStack.length > 0) {
      const startLine = beginStack.pop();
      matches.push({
        from: startLine,
        to: lineNumber
      });
    }
  });
  while (beginStack.length > 0) {
    const startLine = beginStack.pop();
    matches.push({
      from: startLine,
      to: lines.length
      // Set end to last line for unmatched BEGIN
    });
  }
  return matches;
}
const editorMarkers = /* @__PURE__ */ new WeakMap();
function clearMarkersForClass(editor, className) {
  var _a, _b;
  const markers = (_a = editorMarkers.get(editor)) == null ? void 0 : _a.get(className);
  if (!markers) return;
  markers.forEach((marker) => {
    if (marker.find()) {
      marker.clear();
    }
  });
  (_b = editorMarkers.get(editor)) == null ? void 0 : _b.delete(className);
}
function storeMarkersForClass(editor, className, markers) {
  if (!editorMarkers.has(editor)) {
    editorMarkers.set(editor, /* @__PURE__ */ new Map());
  }
  const editorMap = editorMarkers.get(editor);
  if (editorMap) {
    editorMap.set(className, markers);
  }
}
function CodeAreaMarkTextPattern(editor, pattern, options, excludePatterns) {
  const { className } = options;
  clearMarkersForClass(editor, className);
  const doc = editor.getDoc();
  const content = doc.getValue();
  const excludeRanges = (excludePatterns == null ? void 0 : excludePatterns.flatMap(
    (excludePattern) => Array.from(content.matchAll(excludePattern), (match) => ({
      start: match.index,
      end: match.index + match[0].length
    }))
  )) ?? [];
  const markers = Array.from(content.matchAll(pattern)).filter((match) => {
    if (excludeRanges.some(
      (range) => match.index >= range.start && match.index < range.end
    )) {
      return false;
    }
    return !match[1] || match[1].trim().length > 0;
  }).map((match) => {
    const startPos = doc.posFromIndex(match.index);
    const endPos = doc.posFromIndex(match.index + match[0].length);
    return editor.markText(startPos, endPos, {
      atomic: false,
      clearOnEnter: false,
      ...options
    });
  });
  if (markers.length > 0) {
    storeMarkersForClass(editor, className, markers);
  }
}
function markInlineCode(editor, className = "cm-inline-code") {
  const inlineCodePattern = /`([^`\n\r]+)`/g;
  const codeBlockPattern = /```[\s\S]*?```/g;
  CodeAreaMarkTextPattern(
    editor,
    inlineCodePattern,
    {
      className
    },
    [codeBlockPattern]
  );
}
function markInlineLinks(editor, className = "cm-inline-url") {
  const inlineLinkPattern = /<((?:https?:\/\/[^\s<>]+)|(?:[^\s<>@]+@[^\s<>@]+\.[^\s<>@]+))>/g;
  const codeBlockPattern = /```[\s\S]*?```/g;
  CodeAreaMarkTextPattern(
    editor,
    inlineLinkPattern,
    {
      className
    },
    [codeBlockPattern]
  );
}
function markCodeBlocks(editor, className = "cm-code-block") {
  const doc = editor.getDoc();
  const content = doc.getValue();
  const lineCount = content.split("\n").length;
  for (let i = 0; i < lineCount; i++) {
    ["background", "wrap", "text"].forEach(
      (where) => editor.removeLineClass(i, where, className)
    );
  }
  const codeBlockPattern = /```[\s\S]*?(?:```|$)/g;
  Array.from(content.matchAll(codeBlockPattern)).forEach((match) => {
    const startPos = doc.posFromIndex(match.index);
    const endPos = doc.posFromIndex(match.index + match[0].length);
    for (let lineNum = startPos.line; lineNum <= endPos.line; lineNum++) {
      editor.addLineClass(lineNum, "wrap", className);
    }
  });
}
function markTextPrecededBySymbol(editor, symbol, className = "cm-symbol-text") {
  const escapedSymbol = symbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const codeBlockPattern = /```[\s\S]*?```/g;
  const symbolTextPattern = new RegExp(
    `(?<=^|\\s)(${escapedSymbol}[^\\s]+)`,
    "g"
  );
  CodeAreaMarkTextPattern(
    editor,
    symbolTextPattern,
    {
      className
    },
    [codeBlockPattern]
  );
}
function foldCode(editor, { from, to }) {
  editor.foldCode(
    0,
    {
      rangeFinder: () => {
        if (!to) return;
        return {
          from: { line: from - 1, ch: 0 },
          to: { line: to - 1, ch: 0 }
        };
      }
    },
    "fold"
  );
}
function CodeAreaInput({
  options,
  value,
  defaultValue,
  id,
  onEditorDidMount,
  onChange,
  onBlur,
  onFocus,
  placeholder,
  disabled,
  size = "small",
  height,
  autoFoldControlBlocks,
  "data-testid": dataTestId,
  "aria-label": ariaLabel,
  ...props
}) {
  var _a;
  const editorRef = useRef();
  const [editor, setEditor] = useState(null);
  const initialFoldingDoneRef = useRef(false);
  const codeMirrorOptions = {
    mode: "sql",
    theme: "light",
    addModeClass: true,
    lineNumbers: true,
    lineWrapping: true,
    extraKeys: { "Ctrl-Space": "autocomplete" },
    placeholder,
    disabled,
    gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
    styleActiveLine: { nonEmpty: true },
    styleActiveSelected: true,
    matchBrackets: true,
    foldOptions: {
      minFoldSize: 1,
      scanUp: false
    },
    ...options
  };
  useEffect(() => {
    return () => {
      setEditor(null);
    };
  }, []);
  useEffect(() => {
    if (!value || !editor || !autoFoldControlBlocks || initialFoldingDoneRef.current)
      return;
    const numberOfBlocks = findCodeAreaControlCodeOccurrences(value);
    if (!numberOfBlocks.length) return;
    for (const line of numberOfBlocks) {
      foldCode(editor, line);
    }
    initialFoldingDoneRef.current = true;
  }, [value, editor, autoFoldControlBlocks]);
  useEffect(() => {
    const mode = typeof (options == null ? void 0 : options.mode) === "object" && options.mode !== null ? options.mode.name : options == null ? void 0 : options.mode;
    if (mode !== "markdown" || !editor || !value) return;
    markInlineCode(editor);
    markInlineLinks(editor);
    markCodeBlocks(editor);
  }, [editor, value, options == null ? void 0 : options.mode]);
  return /* @__PURE__ */ jsxs(
    CodeAreaTheme,
    {
      size,
      height,
      id,
      "data-size": size,
      "data-height": height,
      "data-mode": typeof (options == null ? void 0 : options.mode) === "object" && ((_a = options.mode) == null ? void 0 : _a.name) ? options.mode.name : options == null ? void 0 : options.mode,
      "data-fold-gutter": options == null ? void 0 : options.foldGutter,
      "data-testid": dataTestId,
      "aria-label": ariaLabel ?? "Code editor text area",
      "data-name": "code-area-input",
      children: [
        value !== void 0 && /* @__PURE__ */ jsx(
          Controlled,
          {
            ...props,
            value,
            editorDidMount: (editor2) => {
              editorRef.current = editor2;
              setEditor(editor2);
              onEditorDidMount == null ? void 0 : onEditorDidMount(editor2);
            },
            options: codeMirrorOptions,
            onBeforeChange: (editor2, data, value2) => {
              onChange == null ? void 0 : onChange(value2);
            },
            onBlur: (editor2) => {
              onBlur == null ? void 0 : onBlur(editor2.getValue());
            },
            onFocus
          }
        ),
        defaultValue !== void 0 && /* @__PURE__ */ jsx(
          UnControlled,
          {
            ...props,
            value: defaultValue,
            editorDidMount: (editor2) => {
              editorRef.current = editor2;
              setEditor(editor2);
              onEditorDidMount == null ? void 0 : onEditorDidMount(editor2);
            },
            options: codeMirrorOptions,
            onBlur: (editor2) => {
              onBlur == null ? void 0 : onBlur(editor2.getValue());
            },
            onFocus
          }
        )
      ]
    }
  );
}
const Root$3 = styled(FormControl)(() => ({
  display: "flex",
  flexDirection: "column",
  flex: 1
}));
const CodeMirrorWrapper = styled(Box, {
  shouldForwardProp: (prop) => ![
    "variant",
    "error",
    "disabled",
    "readOnly",
    "lineNumbers",
    "fullScreen"
  ].includes(prop)
})(
  ({ variant, error, disabled, readOnly, lineNumbers, fullScreen, theme }) => ({
    position: "relative",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    width: "100%",
    minHeight: 0,
    background: theme.palette.background.paper,
    // Active line addon
    ".CodeMirror-focused .CodeMirror-activeline": {
      "& .CodeMirror-activeline-background, & .CodeMirror-activeline-gutter": {
        background: theme.palette.primary.background
      }
    },
    ...fullScreen && {
      maxWidth: "100%",
      maxHeight: "100vh",
      height: "100vh"
    },
    ...(variant === "filled" || variant === "outlined") && {
      borderRadius: theme.spacing(0.5),
      transition: theme.transitions.create("background-color", {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.shortest
      }),
      "&:after": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: "none",
        border: `1px solid ${theme.palette.default.outlinedBorder}`,
        borderRadius: theme.spacing(0.5),
        transition: theme.transitions.create("border-color", {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.shortest
        })
      },
      "&:hover:after": {
        borderColor: theme.palette.common.black
      },
      "&:focus-within": {
        overflow: "hidden",
        "&:after": {
          borderWidth: "2px",
          borderColor: theme.palette.primary.main
        }
      },
      ...error && {
        "&.MuiBox-root:after": {
          borderWidth: "2px",
          borderColor: theme.palette.error.main
        }
      }
    },
    ...variant === "filled" && {
      backgroundColor: theme.palette.background.paper,
      "&.codeArea-filled:after": {
        borderColor: "transparent"
      },
      "&.codeArea-filled:hover:after": {
        borderColor: theme.palette.common.black
      },
      "&.codeArea-filled:focus-within:after": {
        borderWidth: "2px",
        borderColor: theme.palette.primary.main
      },
      "& .CodeMirror": {
        backgroundColor: theme.palette.default.background,
        "&:focus-within": {
          backgroundColor: theme.palette.background.paper
        }
      },
      ...error && {
        borderColor: theme.palette.error.main,
        "& .CodeMirror": {
          backgroundColor: theme.palette.default.background
        },
        "&:hover, &:focus-within, &.codeArea-filled:after, &.codeArea-filled:hover:after, &.codeArea-filled:focus-within:after": {
          borderColor: theme.palette.error.main
        },
        "&:focus-within": {
          "& .CodeMirror": {
            backgroundColor: theme.palette.background.paper
          }
        }
      }
    },
    ...readOnly && {
      "& .CodeMirror": {
        backgroundColor: theme.palette.default.background,
        ".CodeMirror-cursors": {
          visibility: "hidden !important"
        }
      },
      ...variant === "filled" && {
        backgroundColor: theme.palette.background.paper
      }
    },
    ...disabled && {
      pointerEvents: "none",
      "& .CodeMirror": {
        color: theme.palette.text.disabled,
        backgroundColor: theme.palette.default.background,
        "& span, .CodeMirror-linenumber, .CodeMirror-guttermarker-subtle": {
          color: theme.palette.text.disabled
        }
      },
      ...variant === "filled" && {
        backgroundColor: theme.palette.background.paper
      }
    },
    ...!lineNumbers && {
      "& .CodeMirror-scroll .CodeMirror-sizer": {
        marginLeft: `${theme.spacing(1)} !important`
      },
      "& .CodeMirror-gutter-background": {
        width: `${theme.spacing(2)} !important`
      }
    }
  })
);
const InputWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hasActions"
})(({ theme, hasActions }) => ({
  flex: "1 1 auto",
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  ...hasActions && {
    ".CodeMirror-line": {
      paddingRight: `${theme.spacing(4)} !important`
    }
  }
}));
const HelpIcon = styled(HelpOutline)(({ theme }) => ({
  width: ICON_SIZE_SMALL,
  height: ICON_SIZE_SMALL,
  fill: theme.palette.text.secondary
}));
function CodeAreaField({
  value,
  defaultValue,
  validate,
  onChange,
  onBlur,
  onFocus,
  label,
  labelHelpTooltip,
  placeholder,
  type,
  disabled,
  copyValue,
  helperText,
  error,
  size = "small",
  variant = "outlined",
  onClickExpand,
  onClickFooter,
  disabledButtonFooter,
  buttonFooterLabelId,
  options,
  id = "code-area-field",
  saveLoading,
  showSaveSnackbar,
  onCloseSaveSnackbar,
  fullScreen,
  isExpanded,
  ...props
}) {
  const [focused, setFocused] = useState(false);
  const readOnly = (options == null ? void 0 : options.readOnly) ?? false;
  const lineNumbers = (options == null ? void 0 : options.lineNumbers) ?? true;
  return /* @__PURE__ */ jsxs(
    Root$3,
    {
      size,
      error,
      disabled,
      "aria-disabled": disabled,
      "data-size": size,
      "data-full-screen": fullScreen,
      "data-variant": variant,
      "data-name": "code-area-field",
      children: [
        label && /* @__PURE__ */ jsx(
          InputLabel,
          {
            htmlFor: id,
            disabled,
            error,
            focused,
            shrink: true,
            children: /* @__PURE__ */ jsx(
              LabelWithIndicator,
              {
                label,
                type,
                icon: labelHelpTooltip ? /* @__PURE__ */ jsx(Tooltip, { title: labelHelpTooltip, children: /* @__PURE__ */ jsx(
                  HelpIcon,
                  {
                    "aria-label": typeof labelHelpTooltip === "string" ? labelHelpTooltip : void 0
                  }
                ) }) : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(
          CodeMirrorWrapper,
          {
            variant,
            error: !!error,
            disabled,
            readOnly,
            lineNumbers,
            className: variant === "filled" ? "codeArea-filled" : "",
            fullScreen,
            children: [
              /* @__PURE__ */ jsx(
                CodeAreaHeader,
                {
                  onClickExpand,
                  copyValue,
                  disabled,
                  size: isExpanded ? "medium" : "small"
                }
              ),
              /* @__PURE__ */ jsx(InputWrapper, { hasActions: !!copyValue || !!onClickExpand, children: /* @__PURE__ */ jsx(
                CodeAreaInput,
                {
                  ...props,
                  id,
                  disabled,
                  value,
                  defaultValue,
                  placeholder,
                  onFocus: () => {
                    setFocused(true);
                    onFocus == null ? void 0 : onFocus();
                  },
                  onBlur: (value2) => {
                    if (onBlur) onBlur(value2);
                    if (onChange) onChange(value2);
                    if (validate) validate(value2);
                    setFocused(false);
                  },
                  onChange,
                  size,
                  options: {
                    ...readOnly && {
                      styleActiveLine: false,
                      matchBrackets: false
                    },
                    ...options
                  }
                }
              ) }),
              /* @__PURE__ */ jsx(
                CodeAreaFooter,
                {
                  buttonFooterLabelId,
                  onClickFooter,
                  disabled,
                  disabledButtonFooter,
                  size: "small",
                  loading: !!saveLoading,
                  showSnackbar: showSaveSnackbar,
                  onCloseSnackbar: onCloseSaveSnackbar
                }
              )
            ]
          }
        ),
        helperText && /* @__PURE__ */ jsx(FormHelperText, { children: helperText })
      ]
    }
  );
}
const ErrorWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  marginBottom: "1px",
  padding: theme.spacing(1.5, 2, 1.5, 5.5),
  "&:before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: 1,
    width: theme.spacing(5),
    background: theme.palette.background.default
  },
  "&:after": {
    content: '""',
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    zIndex: 2,
    background: `linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 40%)`
  },
  ".MuiFormHelperText-root": {
    marginTop: 0
  }
}));
const ErrorContent = styled(Box)(({ theme }) => ({
  position: "relative",
  zIndex: 3,
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1)
}));
function CodeAreaDialogError({
  children,
  hasDivider
}) {
  const theme = useTheme();
  if (!children) return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ErrorWrapper, { children: /* @__PURE__ */ jsxs(ErrorContent, { children: [
      /* @__PURE__ */ jsx(ErrorOutline, { htmlColor: theme.palette.error.main }),
      /* @__PURE__ */ jsx(FormHelperText, { error: true, children })
    ] }) }),
    hasDivider && /* @__PURE__ */ jsx(Divider, {})
  ] });
}
const sizesHeight = {
  [
    "small"
    /* Small */
  ]: "480px",
  [
    "medium"
    /* Medium */
  ]: "640px",
  [
    "large"
    /* Large */
  ]: "640px",
  [
    "xlarge"
    /* XLarge */
  ]: "720px"
};
const dialogDimensionsBySize = {
  [
    "small"
    /* Small */
  ]: {
    width: "432px",
    maxWidth: "432px"
  },
  [
    "medium"
    /* Medium */
  ]: {
    width: "592px",
    maxWidth: "592px"
  },
  [
    "large"
    /* Large */
  ]: {
    width: "768px",
    maxWidth: "768px",
    minHeight: "576px"
  },
  [
    "xlarge"
    /* XLarge */
  ]: {
    width: "calc(100vw - 80px)",
    height: "calc(100vh - 80px)",
    maxWidth: "960px"
  }
};
const DialogPaper = styled(Paper, {
  shouldForwardProp: (prop) => !["fullScreen", "height", "width", "hasForm"].includes(prop)
})(
  ({
    fullScreen,
    height,
    width,
    hasForm,
    size = "small",
    theme
  }) => ({
    "&.MuiPaper-root": {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      margin: theme.spacing(5),
      borderRadius: theme.spacing(1),
      ...dialogDimensionsBySize[size],
      maxHeight: sizesHeight[size],
      [`@media (max-height:${sizesHeight[size]})`]: {
        maxHeight: "calc(100vh - 80px)",
        ...size === "large" && {
          minHeight: height !== "auto" ? "calc(100vh - 80px)" : "auto"
        }
      },
      ...fullScreen && {
        width: "100vw",
        maxWidth: `calc(100vw - ${theme.spacing(10)})`,
        height: "100vh",
        maxHeight: `calc(100vh - ${theme.spacing(10)})`,
        margin: theme.spacing(5),
        borderRadius: theme.spacing(1)
      },
      ...height && {
        height,
        minHeight: height
      },
      ...width && {
        width
      },
      [theme.breakpoints.down("sm")]: {
        position: "absolute",
        width: "100%",
        maxWidth: "100%",
        height: "100vh",
        maxHeight: "100vh",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: 0,
        borderRadius: 0,
        ...height && {
          top: "auto",
          borderRadius: theme.spacing(1, 1, 0, 0),
          height,
          minHeight: height
        }
      },
      // Special case for Dialogs wrapped in Form
      ...hasForm && {
        maxHeight: `calc(100vh - ${theme.spacing(10)})`,
        form: {
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          overflow: "hidden",
          ...dialogDimensionsBySize[size],
          maxWidth: "100%",
          ...fullScreen && {
            width: "100%",
            maxWidth: "100%",
            height: "100%",
            maxHeight: "100%"
          },
          ...height && {
            height,
            minHeight: height
          },
          ...width && {
            width
          },
          [theme.breakpoints.down("sm")]: {
            width: "100%",
            maxWidth: "100%",
            height: "100vh",
            maxHeight: "100vh",
            ...height && {
              top: "auto",
              borderRadius: theme.spacing(1, 1, 0, 0),
              height,
              minHeight: height
            }
          }
        }
      }
    }
  })
);
function _Dialog({
  nonModal,
  children,
  size = "small",
  PaperProps,
  fullScreen,
  height,
  width,
  hasForm,
  "aria-label": ariaLabel,
  "data-testid": dataTestId,
  ...props
}, ref) {
  if (nonModal) {
    return /* @__PURE__ */ jsx(
      DialogPaper,
      {
        size,
        fullScreen,
        height,
        width,
        hasForm,
        "aria-label": ariaLabel,
        "data-testid": dataTestId,
        "data-name": "dialog",
        ...props,
        ref,
        children
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Dialog$1,
    {
      PaperComponent: DialogPaper,
      PaperProps: {
        ...PaperProps,
        size,
        fullScreen,
        height,
        width,
        hasForm
      },
      fullScreen,
      role: "section",
      "aria-label": ariaLabel,
      "data-testid": dataTestId,
      "data-size": size,
      "data-width": width,
      "data-height": height,
      "data-name": "dialog",
      ...props,
      ref,
      children
    }
  );
}
const Dialog = forwardRef(_Dialog);
const DialogTitle = styled(DialogTitle$1)(() => ({
  padding: 0,
  zIndex: 10
}));
const Main$1 = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(2),
  minHeight: theme.spacing(8)
}));
const ItemsWrapper$1 = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  overflow: "hidden"
}));
const CloseIcon = styled(CloseOutlined)(({ theme }) => ({
  color: theme.palette.text.secondary
}));
const DividerBottom = styled(Divider)(() => ({
  "+ .MuiDialogContent-root": {
    borderTop: "none !important"
  }
}));
function DialogHeader({
  title,
  chipLabel,
  chipProps,
  children,
  onClose,
  secondaryActions,
  "aria-label": ariaLabel,
  closeIcon,
  closeTooltipText,
  tooltipProps,
  iconButtonProps,
  ...otherProps
}) {
  const closeTooltipLabel = useTranslationWithFallback(
    "c4r.button.close",
    closeTooltipText
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(DialogTitle, { component: "div", "data-name": "dialog-header", ...otherProps, children: [
      /* @__PURE__ */ jsxs(Main$1, { children: [
        /* @__PURE__ */ jsxs(ItemsWrapper$1, { flex: 1, maxWidth: 0.8, children: [
          /* @__PURE__ */ jsx(
            Typography,
            {
              component: "h2",
              variant: "inherit",
              noWrap: true,
              "aria-label": ariaLabel,
              role: "heading",
              children: title
            }
          ),
          chipLabel && /* @__PURE__ */ jsx(Chip, { color: "default", label: chipLabel, ...chipProps })
        ] }),
        /* @__PURE__ */ jsxs(ItemsWrapper$1, { children: [
          secondaryActions,
          onClose && /* @__PURE__ */ jsx(
            Tooltip,
            {
              title: closeTooltipLabel,
              placement: "left",
              ...tooltipProps,
              children: /* @__PURE__ */ jsx(IconButton$1, { onClick: onClose, ...iconButtonProps, children: closeIcon || /* @__PURE__ */ jsx(CloseIcon, { "data-testid": "CloseIcon" }) })
            }
          )
        ] })
      ] }),
      children
    ] }),
    children && /* @__PURE__ */ jsx(DividerBottom, {})
  ] });
}
const Content$4 = styled(DialogContent$1, {
  shouldForwardProp: (prop) => ![
    "scrollableContent",
    "withGutter",
    "withBottomGutter",
    "spacing"
  ].includes(prop)
})(
  ({
    theme,
    scrollableContent,
    withGutter,
    withBottomGutter,
    spacing = 3
  }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(spacing),
    padding: 0,
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    ".MuiAlert-root": {
      minHeight: "auto"
    },
    ...scrollableContent && {
      borderBottom: `1px solid ${theme.palette.divider}`,
      "+ .MuiDivider-root": {
        display: "none"
      }
    },
    ...withGutter && {
      padding: ` ${theme.spacing(1, 2, 0)} !important`,
      ".MuiDialog-paperFullScreen &": {
        padding: `${theme.spacing(2, 2, 0)} !important`
      }
    },
    ...withBottomGutter && {
      paddingBottom: `${theme.spacing(3)} !important`,
      ".MuiDialog-paperFullScreen &": {
        paddingBottom: `${theme.spacing(3)} !important`
      }
    }
  })
);
function _DialogContent({
  children,
  scrollableContent,
  hasFooterAlert,
  withGutter = true,
  withBottomGutter = true,
  spacing,
  onScroll,
  ...props
}, ref) {
  const theme = useTheme();
  const [contentRef, setContentRef] = useState(null);
  useImperativeHandle(
    ref,
    () => contentRef,
    [contentRef]
  );
  const updateBorders = useCallback(
    (node) => {
      const bottom = Math.abs(node.scrollHeight - node.clientHeight - node.scrollTop) < 1;
      const top = node.scrollTop === 0;
      const borderStyle = `1px solid ${theme.palette.divider}`;
      node.style.borderTop = top ? "none" : borderStyle;
      node.style.borderBottom = bottom && !hasFooterAlert ? "none" : borderStyle;
    },
    [theme.palette.divider, hasFooterAlert]
  );
  const handleScroll = useCallback(
    (event) => {
      updateBorders(event.target);
      onScroll == null ? void 0 : onScroll(event);
    },
    [updateBorders, onScroll]
  );
  useEffect(() => {
    if (!contentRef) return;
    updateBorders(contentRef);
  }, [contentRef, updateBorders]);
  useEffect(() => {
    if (!contentRef || typeof ResizeObserver === "undefined") return;
    const resizeObserver = new ResizeObserver(() => {
      updateBorders(contentRef);
    });
    resizeObserver.observe(contentRef);
    return () => resizeObserver.disconnect();
  }, [contentRef, updateBorders]);
  return /* @__PURE__ */ jsx(
    Content$4,
    {
      ref: setContentRef,
      onScroll: handleScroll,
      scrollableContent,
      withGutter,
      withBottomGutter: withBottomGutter && withGutter,
      spacing,
      "data-name": "dialog-content",
      ...props,
      children
    }
  );
}
const DialogContent = forwardRef(_DialogContent);
const DialogContentPadded = styled(DialogContent, {
  shouldForwardProp: (prop) => prop !== "withAlert"
})(({ withAlert, theme }) => ({
  padding: `${theme.spacing(0, 2)} !important`,
  ...withAlert && {
    paddingBottom: `${theme.spacing(3)} !important`
  }
}));
const StyledAlert = styled(Alert$1)(({ theme }) => ({
  minHeight: "auto",
  padding: 0,
  backgroundColor: "transparent",
  "& .MuiTypography-root": {
    color: theme.palette.text.secondary,
    a: {
      color: theme.palette.primary.main
    }
  },
  "& .MuiAlertTitle-root": {
    color: theme.palette.text.primary
  }
}));
function DialogAlert({
  children,
  severity = "neutral",
  ...otherProps
}) {
  return /* @__PURE__ */ jsx(StyledAlert, { severity, ...otherProps, "data-name": "dialog-alert", children });
}
const Root$2 = styled(Box, {
  shouldForwardProp: (prop) => !["dark", "hasChildren"].includes(prop)
})(({ dark, hasChildren, theme }) => ({
  flex: "0 0 auto",
  display: "block",
  minHeight: hasChildren ? theme.spacing(8) : "auto",
  zIndex: 10,
  ...dark && {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.white[60],
    ".MuiAlert-root": {
      ".MuiTypography-root, .MuiAlert-message :not(.MuiAlertTitle-root)": {
        color: theme.palette.white[60],
        a: {
          color: `${theme.palette.secondary.main} !important`
        }
      },
      ".MuiAlert-icon": {
        color: theme.palette.white[60]
      }
    }
  }
}));
const Main = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "& > div:empty": {
    padding: 0
  }
}));
const ItemsWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hasAlert"
})(({ hasAlert, theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  paddingTop: hasAlert ? 0 : theme.spacing(2)
}));
const DialogActions = styled(DialogActions$1, {
  shouldForwardProp: (prop) => prop !== "hasAlert"
})(({ hasAlert, theme }) => ({
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  paddingTop: hasAlert ? 0 : theme.spacing(2),
  margin: 0,
  ".MuiButton-root + .MuiButton-root": {
    marginLeft: 0
  }
}));
const DividerTop = styled(Divider)(() => ({
  // To prevent double border in the top when content is scrollable
  marginTop: "-1px"
}));
function DialogFooter({
  children,
  secondaryActions,
  alertContent,
  alertProps,
  dark,
  topContent,
  ...otherProps
}) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    topContent,
    !!alertContent && /* @__PURE__ */ jsx(DividerTop, {}),
    /* @__PURE__ */ jsxs(
      Root$2,
      {
        ...otherProps,
        dark,
        "data-theme": dark ? "dark" : "light",
        "data-name": "dialog-footer",
        hasChildren: !!children,
        children: [
          !!alertContent && /* @__PURE__ */ jsx(Box, { sx: { p: 2, pt: 1.5, pb: 1 }, children: /* @__PURE__ */ jsx(DialogAlert, { ...alertProps, children: alertContent }) }),
          /* @__PURE__ */ jsxs(Main, { children: [
            /* @__PURE__ */ jsx(ItemsWrapper, { hasAlert: !!alertContent, children: secondaryActions }),
            /* @__PURE__ */ jsx(DialogActions, { hasAlert: !!alertContent, children })
          ] })
        ]
      }
    )
  ] });
}
const Backdrop = styled(Box)(({ theme }) => ({
  position: "absolute",
  width: "100%",
  zIndex: 100,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  overflow: "hidden",
  display: "flex",
  boxSizing: "border-box",
  alignItems: "flex-end",
  background: theme.palette.white[60]
}));
const AnimationWrapper = styled("div")(() => ({
  width: "100%"
}));
const BackdropContent = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(1.5, 2, 2),
  backgroundColor: theme.palette.background.paper,
  borderTop: `1px solid ${theme.palette.divider}`,
  ".MuiDialogActions-root": {
    padding: 0,
    marginTop: theme.spacing(1)
  }
}));
function DialogConfirmation({
  children,
  onClickAway,
  actions,
  severity = "warning",
  opened,
  "data-testid": dataTestId,
  "aria-label": ariaLabel,
  slideProps,
  ...alertProps
}) {
  const containerRef = useRef(null);
  const theme = useTheme();
  const timeout = (slideProps == null ? void 0 : slideProps.timeout) ?? 350;
  const direction = (slideProps == null ? void 0 : slideProps.direction) ?? "up";
  const handleClickAway = () => {
    if (onClickAway) {
      onClickAway();
    }
  };
  return /* @__PURE__ */ jsx(
    Backdrop,
    {
      ref: containerRef,
      "data-testid": dataTestId,
      "aria-label": ariaLabel,
      role: "presentation",
      "data-name": "dialog-confirmation",
      children: /* @__PURE__ */ jsx(ClickAwayListener$1, { onClickAway: handleClickAway, children: /* @__PURE__ */ jsx(
        Slide,
        {
          mountOnEnter: true,
          unmountOnExit: true,
          easing: theme.transitions.easing.easeOut,
          direction,
          timeout,
          ...slideProps,
          in: opened,
          container: containerRef.current,
          "data-name": "dialog-confirmation-slide",
          "data-direction": direction,
          "data-timeout": timeout,
          children: /* @__PURE__ */ jsx(AnimationWrapper, { children: /* @__PURE__ */ jsxs(BackdropContent, { children: [
            /* @__PURE__ */ jsx(DialogAlert, { severity, ...alertProps, children }),
            /* @__PURE__ */ jsx(DialogActions, { children: actions })
          ] }) })
        }
      ) })
    }
  );
}
const Root$1 = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: theme.spacing(8),
  marginBottom: theme.spacing(2),
  "& > div": {
    flex: 1
  }
}));
const StepContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  "&:before, &:after": {
    content: '""',
    background: theme.palette.divider,
    position: "absolute",
    top: theme.spacing(1.25),
    height: theme.spacing(0.25),
    width: `calc(50% - ${theme.spacing(2.5)})`
  },
  "&:before": {
    left: 0
  },
  "&:after": {
    right: 0
  },
  "&:first-of-type:before": {
    content: "none"
  },
  "&:last-of-type:after": {
    content: "none"
  }
}));
function getStepNumberColors({
  theme,
  completed,
  current
}) {
  if (completed) {
    return {
      background: theme.palette.success.main,
      borderColor: theme.palette.success.main,
      color: theme.palette.common.white
    };
  } else if (current) {
    return {
      background: theme.palette.text.primary,
      borderColor: theme.palette.text.primary,
      color: theme.palette.common.white
    };
  } else {
    return {
      borderColor: theme.palette.text.secondary,
      color: theme.palette.text.secondary
    };
  }
}
const StepNumber = styled("span", {
  shouldForwardProp: (prop) => prop !== "completed" && prop !== "current"
})(({ theme, completed, current }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: theme.spacing(3),
  width: theme.spacing(3),
  marginBottom: theme.spacing(1),
  borderRadius: "50%",
  border: `${theme.spacing(0.25)} solid currentColor`,
  ...theme.typography.caption,
  ...getStepNumberColors({ theme, completed, current })
}));
function DialogStepper({
  currentStep,
  stepsLabels,
  ...props
}) {
  return /* @__PURE__ */ jsx(Root$1, { ...props, "data-name": "dialog-stepper", children: /* @__PURE__ */ jsx(Box, { sx: { display: "flex" }, children: stepsLabels.map((stepLabel, idx) => {
    const step = idx + 1;
    const isCurrent = step === currentStep;
    const isCompleted = step < currentStep;
    const labelColor = isCompleted ? "success.main" : isCurrent ? "textPrimary" : "textSecondary";
    return /* @__PURE__ */ jsxs(
      StepContainer,
      {
        "data-state": isCompleted ? "completed" : isCurrent ? "current" : "uncompleted",
        children: [
          /* @__PURE__ */ jsx(StepNumber, { completed: isCompleted, current: isCurrent, children: isCompleted ? /* @__PURE__ */ jsx(Check, { fontSize: "small", "aria-label": "Completed step" }) : step }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", component: "div", color: labelColor, children: stepLabel })
        ]
      },
      idx
    );
  }) }) });
}
const Content$3 = styled(DialogContent, {
  shouldForwardProp: (prop) => !["error", "withBorder"].includes(prop)
})(
  ({ error, withBorder, theme }) => ({
    gap: 0,
    border: withBorder ? `1px solid ${theme.palette.divider} !important` : void 0,
    borderBottom: error ? "none !important" : void 0,
    ".react-codemirror2": {
      display: "flex",
      flexDirection: "column",
      minHeight: "100%"
    },
    ".CodeMirror-wrap": {
      display: "flex",
      flexDirection: "column",
      flex: 1
    },
    "& + .MuiDivider-root": {
      display: "none"
    }
  })
);
function CodeAreaDialogContent({
  children,
  error,
  withBorder = true,
  withGutter = false
}) {
  if (!children) return null;
  return /* @__PURE__ */ jsx(Content$3, { withGutter, error, withBorder, children });
}
function CodeAreaDialogConfirmation({
  onClose,
  onCancel,
  cancelLabelId,
  cancelText,
  cancelButton,
  closeButton,
  contentLabelId,
  contentText,
  titleLabelId,
  titleText,
  severity = "warning",
  content,
  leaveText
}) {
  const titleLabel = useTranslationWithFallback(
    titleLabelId || "c4r.dialog.confirmation.title",
    titleText
  );
  const cancelLabel = useTranslationWithFallback(
    cancelLabelId || "c4r.button.cancel",
    cancelText
  );
  const leaveLabel = useTranslationWithFallback("c4r.button.leave", leaveText);
  const contentLabel = useTranslationWithFallback(
    contentLabelId || "c4r.dialog.confirmation.content",
    contentText
  );
  if (!onClose || !onCancel) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    DialogConfirmation,
    {
      opened: true,
      severity,
      title: titleLabel,
      actions: /* @__PURE__ */ jsxs(Fragment, { children: [
        onCancel && (cancelButton ? cancelButton : /* @__PURE__ */ jsx(Button, { onClick: onCancel, children: cancelLabel })),
        onClose && (closeButton ? closeButton : /* @__PURE__ */ jsx(Button, { variant: "contained", onClick: onClose, children: leaveLabel }))
      ] }),
      children: content ?? contentLabel
    }
  );
}
function CodeAreaDialog({
  open,
  onClose,
  title,
  error,
  helperText,
  onClickFooter,
  disabledButtonFooter,
  buttonFooterLabelId,
  disabled,
  showConfirmation,
  onCancelConfirm,
  onCloseConfirm,
  confirmationDialogTexts,
  footerProps,
  saveLoading,
  showSaveSnackbar,
  onCloseSaveSnackbar,
  "data-testid": dataTestId,
  "aria-label": ariaLabel,
  ...props
}) {
  const showFooter = error || !!onClickFooter || !!footerProps;
  if (!open) return null;
  return /* @__PURE__ */ jsxs(
    Dialog,
    {
      open,
      fullScreen: true,
      onClose,
      "data-testid": dataTestId,
      "aria-label": ariaLabel,
      "data-name": "code-area-dialog",
      children: [
        /* @__PURE__ */ jsx(
          DialogHeader,
          {
            title,
            onClose,
            closeIcon: !onClickFooter && /* @__PURE__ */ jsx(CloseDiagonallyRight, {})
          }
        ),
        /* @__PURE__ */ jsx(CodeAreaDialogContent, { error, children: /* @__PURE__ */ jsx(
          CodeAreaField,
          {
            ...props,
            disabled,
            variant: null,
            isExpanded: true
          }
        ) }),
        showFooter && /* @__PURE__ */ jsx(
          DialogFooter,
          {
            ...footerProps,
            topContent: error && /* @__PURE__ */ jsx(CodeAreaDialogError, { hasDivider: !!onClickFooter, children: helperText }),
            children: !!onClickFooter && /* @__PURE__ */ jsx(
              CodeAreaFooter,
              {
                onClickFooter,
                buttonFooterLabelId,
                disabled,
                disabledButtonFooter,
                withGutter: false,
                variant: "contained",
                size: "medium",
                loading: !!saveLoading,
                showSnackbar: showSaveSnackbar,
                onCloseSnackbar: onCloseSaveSnackbar
              }
            )
          }
        ),
        showConfirmation && /* @__PURE__ */ jsx(
          CodeAreaDialogConfirmation,
          {
            onClose: onCloseConfirm ?? onClose,
            onCancel: onCancelConfirm,
            cancelLabelId: "c4r.button.keepEditing",
            titleText: confirmationDialogTexts == null ? void 0 : confirmationDialogTexts.titleText,
            contentText: confirmationDialogTexts == null ? void 0 : confirmationDialogTexts.contentText,
            cancelText: confirmationDialogTexts == null ? void 0 : confirmationDialogTexts.cancelText,
            leaveText: confirmationDialogTexts == null ? void 0 : confirmationDialogTexts.leaveText
          }
        )
      ]
    }
  );
}
const useCodeAreaAutocompletion = (editor, config) => {
  const { triggers } = config;
  useEffect(() => {
    if (!editor) return;
    const closeHints = (cm) => {
      var _a;
      const active = (_a = cm.state) == null ? void 0 : _a.completionActive;
      if (active == null ? void 0 : active.close) active.close();
    };
    const showAutocomplete = (cm) => {
      const cursor = cm.getCursor();
      const line = cm.getLine(cursor.line);
      const textBeforeCursor = line.slice(0, cursor.ch);
      let atIndex = -1;
      let foundTriggerConfig = null;
      for (let i = textBeforeCursor.length - 1; i >= 0; i--) {
        const char = textBeforeCursor[i];
        const triggerConfig = triggers.find((t) => t.symbol === char);
        if (triggerConfig) {
          const beforeTrigger = textBeforeCursor.slice(0, i);
          if (beforeTrigger.length === 0 || beforeTrigger.endsWith(" ")) {
            atIndex = i;
            foundTriggerConfig = triggerConfig;
            break;
          }
        }
      }
      if (atIndex === -1 || !foundTriggerConfig) {
        closeHints(cm);
        return;
      }
      const query = textBeforeCursor.slice(atIndex + 1);
      if (query.includes(" ")) {
        closeHints(cm);
        return;
      }
      const filtered = foundTriggerConfig.getItems(query);
      if (filtered.length === 0) {
        closeHints(cm);
        return;
      }
      cm.showHint({
        hint: () => ({
          list: filtered.map((item) => ({
            text: item.value + " ",
            render: (element) => {
              element.innerHTML = DOMPurify.sanitize(item.html);
            }
          })),
          from: { line: cursor.line, ch: atIndex + 1 },
          to: cursor
        }),
        completeSingle: false,
        closeOnUnfocus: true
      });
    };
    const handleChange = () => showAutocomplete(editor);
    const handleKeydown = (cm, event) => {
      if (event.key === "Escape") closeHints(cm);
    };
    editor.on("change", handleChange);
    editor.on("keydown", handleKeydown);
    return () => {
      editor.off("change", handleChange);
      editor.off("keydown", handleKeydown);
    };
  }, [editor, triggers]);
};
const Container = styled(Box, {
  shouldForwardProp: (prop) => !["size", "variant"].includes(prop)
})(({ size, variant, theme }) => ({
  position: "absolute",
  right: theme.spacing(5.75),
  ...size === "small" && {
    right: theme.spacing(4),
    top: "3px"
    // to align with design specs
  },
  ...variant === "standard" && {
    right: theme.spacing(4.75),
    ...size === "small" && {
      right: theme.spacing(3.5)
    }
  }
}));
function ClearButton({
  size,
  variant,
  ...props
}) {
  const intl = useIntl();
  const intlConfig = useImperativeIntl(intl);
  return /* @__PURE__ */ jsx(Container, { size, variant, children: /* @__PURE__ */ jsx(
    IconButton$1,
    {
      ...props,
      size,
      "aria-label": intlConfig.formatMessage({
        id: "c4r.form.clearSelection"
      })
    }
  ) });
}
const Root = styled(Box, {
  shouldForwardProp: (prop) => !["size", "variant", "readOnly"].includes(prop)
})(({ size, variant, readOnly, theme }) => ({
  // There is no specific slot to change TextField styles at DatePicker level, so we need to wrap our component to isolate this override. https://mui.com/x/react-date-pickers/date-picker/#customization
  ".MuiInputBase-root": {
    "& .clearButton svg": {
      color: theme.palette.text.hint
    },
    ...size === "small" && {
      paddingRight: `${theme.spacing(1)} !important`
    },
    ...size === "medium" && {
      "& .MuiInputAdornment-root": {
        "& .MuiIconButton-edgeEnd": {
          marginRight: theme.spacing(-1)
        }
      }
    },
    ...variant === "standard" && {
      paddingRight: `${theme.spacing(1)} !important`,
      ...size === "small" && {
        paddingRight: `${theme.spacing(0.5)} !important`
      }
    },
    ...readOnly && {
      "& .MuiInputAdornment-root": {
        "& svg": {
          color: theme.palette.text.disabled
        }
      }
    }
  }
}));
function DateFieldContainer({
  children,
  size,
  variant,
  readOnly,
  ...props
}) {
  return /* @__PURE__ */ jsx(Root, { ...props, size, variant, readOnly, children });
}
function DatePicker({
  handleClear,
  variant = "outlined",
  size = "small",
  label,
  labelHelpTooltip,
  type,
  helperText,
  placeholder,
  slotProps,
  slots,
  error,
  showCalendar = true,
  readOnly,
  "aria-label": ariaLabel,
  "data-testid": dataTestId,
  chooseDateAriaLabel,
  ...props
}) {
  const chooseDateText = useTranslationWithFallback(
    "c4r.form.chooseDate",
    chooseDateAriaLabel
  );
  return (
    // Don't remove className, it's used for styling
    /* @__PURE__ */ jsx(Box, { className: "CartoDatePicker-root", "data-testid": "date-picker", children: /* @__PURE__ */ jsx(
      DateFieldContainer,
      {
        size,
        variant,
        readOnly,
        "data-name": "date-picker",
        "aria-label": ariaLabel,
        "data-testid": dataTestId,
        children: /* @__PURE__ */ jsx(
          DatePicker$1,
          {
            ...props,
            label: label && /* @__PURE__ */ jsx(
              LabelWithIndicator,
              {
                label,
                type,
                icon: labelHelpTooltip && /* @__PURE__ */ jsx(Tooltip, { title: labelHelpTooltip, children: /* @__PURE__ */ jsx(HelpOutline, { htmlColor: "text.secondary" }) })
              }
            ),
            slotProps: {
              // https://mui.com/x/api/date-pickers/date-picker/#slots
              textField: {
                variant,
                helperText,
                placeholder,
                size,
                error: error ?? void 0,
                // undefined is needed to allow the component to control the error state for the default validation
                inputProps: {
                  "data-testid": "date-picker-input"
                }
              },
              field: {
                clearable: !!handleClear,
                onClear: handleClear
              },
              ...slotProps
            },
            slots: {
              clearButton: (props2) => /* @__PURE__ */ jsx(ClearButton, { ...props2, size, variant }),
              openPickerButton: (props2) => /* @__PURE__ */ jsx(IconButton$1, { ...props2, size, "aria-label": chooseDateText }),
              ...slots
            },
            disableOpenPicker: !showCalendar,
            readOnly
          }
        )
      }
    ) })
  );
}
const PickersDayWrapper = styled(Box, {
  shouldForwardProp: (prop) => ![
    "isSelected",
    "isStartDate",
    "isEndDate",
    "isSelectedMonth",
    "isLastDay",
    "isFirstDay"
  ].includes(prop)
})(
  ({
    theme,
    isSelected,
    isStartDate,
    isEndDate,
    isSelectedMonth,
    isLastDay,
    isFirstDay
  }) => ({
    position: "relative",
    margin: theme.spacing(0.25),
    "& .MuiPickersDay-root": {
      margin: 0
    },
    // Highlight the selected date range
    ...isSelected && isSelectedMonth && {
      // Creates a continuous background color between start and end date
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        right: "-2px",
        bottom: 0,
        left: "-2px",
        backgroundColor: theme.palette.primary.background,
        // Selected start date OR first day of the month
        ...(isStartDate || isFirstDay) && {
          left: 0,
          borderRadius: `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`
        },
        // Selected end date OR last day of the month
        ...(isEndDate || isLastDay) && {
          right: 0,
          borderRadius: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`
        }
      },
      // First selected day
      "&:first-of-type::before": {
        left: 0,
        borderRadius: `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`
      },
      // Last selected day
      "&:last-of-type::before": {
        right: 0,
        borderRadius: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`
      },
      // First day of month and last selected day in a week
      ...isFirstDay && {
        "&:last-of-type::before": {
          left: 0,
          right: 0,
          borderRadius: theme.shape.borderRadius
        }
      },
      // Last day of month and first selected day in a week
      ...isLastDay && {
        "&:first-of-type::before": {
          left: 0,
          right: 0,
          borderRadius: theme.shape.borderRadius
        }
      },
      "& .MuiPickersDay-today": {
        borderColor: `${theme.palette.default.outlinedBorder} !important`,
        ...(isStartDate || isEndDate) && {
          boxShadow: `0 0 0 1px inset ${theme.palette.background.paper}`
        }
      },
      // Always having a solid background color below to avoid color blending
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        transition: "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
      },
      "&:hover::after": {
        backgroundColor: theme.palette.primary.relatedLight
      }
    }
  })
);
const CustomPickersDay = styled(PickersDay$1, {
  shouldForwardProp: (prop) => prop !== "isDateRangeLimit"
})(({ theme, isDateRangeLimit }) => ({
  "&.MuiPickersDay-root": {
    position: "relative",
    zIndex: 1,
    "&.Mui-selected": {
      color: theme.palette.text.primary
    },
    // Is selected date within the range
    ...isDateRangeLimit && {
      "&.Mui-selected": {
        backgroundColor: `${theme.palette.primary.main} !important`,
        color: theme.palette.primary.contrastText,
        "&:hover": {
          backgroundColor: `${theme.palette.primary.dark} !important`
        }
      }
    }
  }
}));
const isSameDay = (d1, d2) => {
  if (!d1 || !d2) return false;
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
};
function PickersDay({
  day,
  startDate,
  endDate,
  selectedMonth,
  ...otherProps
}) {
  const isStartDate = Boolean(startDate && isSameDay(startDate, day));
  const isEndDate = Boolean(endDate && isSameDay(endDate, day));
  const isInsideRange = Boolean(
    startDate && endDate && day.getTime() >= startDate.getTime() && day.getTime() <= endDate.getTime()
  );
  const isFirstDayOfMonth = Boolean(day.getDate() === 1);
  const isLastDayOfMonth = Boolean(
    day.getDate() === new Date(day.getFullYear(), day.getMonth() + 1, 0).getDate()
  );
  const isDayInSelectedMonth = Boolean(
    selectedMonth && day.getMonth() === selectedMonth.getMonth()
  );
  return /* @__PURE__ */ jsx(
    PickersDayWrapper,
    {
      isSelected: isInsideRange,
      isStartDate,
      isEndDate,
      isSelectedMonth: isDayInSelectedMonth,
      isLastDay: isLastDayOfMonth,
      isFirstDay: isFirstDayOfMonth,
      children: /* @__PURE__ */ jsx(
        CustomPickersDay,
        {
          ...otherProps,
          day,
          selected: isInsideRange || isStartDate || isEndDate,
          isDateRangeLimit: isStartDate || isEndDate,
          "data-name": "pickers-day"
        }
      )
    }
  );
}
const FieldsWrapper = styled(Box, {
  shouldForwardProp: (prop) => !["variant"].includes(prop)
})(({ variant, theme }) => ({
  display: "flex",
  gap: variant === "standard" ? theme.spacing(1) : "1px",
  "& .CartoDatePicker-root": {
    // Start date field
    "&:first-of-type": {
      ".MuiInputBase-root": {
        borderRadius: theme.spacing(0.5, 0, 0, 0.5),
        boxShadow: `1px 0 0 0 ${theme.palette.default.outlinedBorder}`,
        ...variant === "outlined" && {
          // Remove border from the right side only in its default state. Nested negation selector to target only specific Mui rules, otherwise it would force us to rewrite the state styles.
          "&:not(:hover):not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
            borderRightColor: "transparent"
          }
        },
        ...variant === "filled" && {
          "&::before, &::after": {
            borderRadius: theme.spacing(0.5, 0, 0, 0.5)
          }
        },
        ...variant === "standard" && {
          boxShadow: "none",
          borderRadius: 0
        }
      }
    },
    // End date field
    "&:last-of-type": {
      ".MuiInputBase-root": {
        borderRadius: theme.spacing(0, 0.5, 0.5, 0),
        ...variant === "outlined" && {
          // Remove border from the left side only in its default state
          "&:not(:hover):not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
            borderLeftColor: "transparent"
          }
        },
        ...variant === "filled" && {
          "&::before, &::after": {
            borderRadius: theme.spacing(0, 0.5, 0.5, 0)
          }
        },
        ...variant === "standard" && {
          borderRadius: 0
        }
      }
    }
  }
}));
function DateRangePicker({
  globalHelperText,
  error,
  variant = "outlined",
  startProps,
  endProps,
  startDateLabel,
  endDateLabel,
  startDateCalendarAriaLabel,
  endDateCalendarAriaLabel,
  "aria-label": ariaLabel,
  "data-testid": dataTestId,
  ...props
}) {
  const [isEndDateOpen, setIsEndDateOpen] = useState(false);
  const [isStartDateOpen, setIsStartDateOpen] = useState(false);
  const [startDate, setStartDate] = useState(
    (startProps == null ? void 0 : startProps.value) || null
  );
  const [endDate, setEndDate] = useState((endProps == null ? void 0 : endProps.value) || null);
  const [selectedMonth, setSelectedMonth] = useState(
    (endProps == null ? void 0 : endProps.value) ?? (startProps == null ? void 0 : startProps.value) ?? /* @__PURE__ */ new Date()
  );
  const hasError = error ?? (startProps == null ? void 0 : startProps.error) ?? (endProps == null ? void 0 : endProps.error);
  const _startDateLabel = useTranslationWithFallback(
    "c4r.form.startDate",
    startDateLabel
  );
  const _endDateLabel = useTranslationWithFallback(
    "c4r.form.endDate",
    endDateLabel
  );
  const startCalendarAriaLabel = useTranslationWithFallback(
    "c4r.form.startDateCalendar",
    startDateCalendarAriaLabel
  );
  const endCalendarAriaLabel = useTranslationWithFallback(
    "c4r.form.endDateCalendar",
    endDateCalendarAriaLabel
  );
  const handleStartDateChange = (value, context) => {
    setStartDate(value);
    if (startProps == null ? void 0 : startProps.onChange) {
      startProps.onChange(value, context);
    }
    if (value && context.validationError === null && !isStartDateOpen && context.trigger === null) {
      setIsStartDateOpen(false);
      setIsEndDateOpen(true);
    }
  };
  const handleEndDateChange = (value, context) => {
    setEndDate(value);
    if (endProps == null ? void 0 : endProps.onChange) {
      endProps.onChange(value, context);
    }
  };
  const handleStartDateOpen = () => {
    setIsStartDateOpen(true);
    setIsEndDateOpen(false);
    setTimeout(() => {
      setSelectedMonth(startDate ?? /* @__PURE__ */ new Date());
    }, 120);
  };
  const handleStartDateClose = () => {
    setIsStartDateOpen(false);
    setIsEndDateOpen(true);
    setTimeout(() => {
      setSelectedMonth(endDate ?? startDate ?? /* @__PURE__ */ new Date());
    }, 120);
  };
  const handleEndDateOpen = () => {
    setIsStartDateOpen(false);
    setIsEndDateOpen(true);
    setTimeout(() => {
      setSelectedMonth(endDate ?? startDate ?? /* @__PURE__ */ new Date());
    }, 120);
  };
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsxs(
      FieldsWrapper,
      {
        variant,
        "data-name": "date-range-picker",
        "aria-label": ariaLabel,
        "data-testid": dataTestId,
        children: [
          /* @__PURE__ */ jsx(
            DatePicker,
            {
              ...props,
              ...startProps,
              value: (startProps == null ? void 0 : startProps.value) ?? startDate,
              maxDate: endDate ?? void 0,
              label: (startProps == null ? void 0 : startProps.label) ?? _startDateLabel,
              slotProps: {
                popper: {
                  placement: "bottom-start",
                  "aria-label": startCalendarAriaLabel
                },
                ...startProps == null ? void 0 : startProps.slotProps
              },
              slots: {
                openPickerIcon: TodayOutlined,
                day: (props2) => /* @__PURE__ */ jsx(
                  PickersDay,
                  {
                    ...props2,
                    startDate,
                    endDate,
                    selectedMonth
                  }
                ),
                ...startProps == null ? void 0 : startProps.slots
              },
              error: (startProps == null ? void 0 : startProps.error) ?? error,
              open: isStartDateOpen,
              onChange: handleStartDateChange,
              onOpen: handleStartDateOpen,
              onClose: handleStartDateClose,
              onMonthChange: (month) => setSelectedMonth(month),
              variant
            }
          ),
          /* @__PURE__ */ jsx(
            DatePicker,
            {
              ...props,
              ...endProps,
              value: (endProps == null ? void 0 : endProps.value) ?? endDate,
              minDate: startDate ?? void 0,
              slotProps: {
                popper: {
                  "aria-label": endCalendarAriaLabel
                },
                ...endProps == null ? void 0 : endProps.slotProps
              },
              slots: {
                day: (props2) => /* @__PURE__ */ jsx(
                  PickersDay,
                  {
                    ...props2,
                    startDate,
                    endDate,
                    selectedMonth
                  }
                ),
                ...endProps == null ? void 0 : endProps.slots
              },
              label: (endProps == null ? void 0 : endProps.label) ?? _endDateLabel,
              error: (endProps == null ? void 0 : endProps.error) ?? error,
              open: isEndDateOpen,
              onOpen: handleEndDateOpen,
              onClose: () => setIsEndDateOpen(false),
              onChange: handleEndDateChange,
              onMonthChange: (month) => setSelectedMonth(month),
              variant
            }
          )
        ]
      }
    ),
    globalHelperText && /* @__PURE__ */ jsx(FormHelperText, { error: hasError, children: globalHelperText })
  ] });
}
const getDateTimeFormat = (views, includeDate, ampm, format) => {
  const hasHours = views == null ? void 0 : views.includes("hours");
  const hasSeconds = views == null ? void 0 : views.includes("seconds");
  const hasMinutes = views == null ? void 0 : views.includes("minutes");
  const hasOnlyHours = (views == null ? void 0 : views.length) === 1 && views[0] === "hours";
  if (format) return format;
  const timeFormatParts = [];
  if (includeDate) {
    timeFormatParts.push("MM/dd/yyyy ");
  }
  if (hasHours) {
    timeFormatParts.push(ampm ? "hh" : "HH");
  }
  if (!hasOnlyHours) {
    timeFormatParts.push(":");
  }
  if (hasMinutes) {
    timeFormatParts.push("mm");
  }
  if (hasSeconds) {
    timeFormatParts.push(":ss");
  }
  if (ampm) {
    timeFormatParts.push(" a");
  }
  return timeFormatParts.join("");
};
function TimePicker({
  handleClear,
  variant = "outlined",
  size = "small",
  label,
  labelHelpTooltip,
  type,
  helperText,
  placeholder,
  error,
  showClock = true,
  readOnly,
  slotProps,
  slots,
  ampm = true,
  views = ["hours", "minutes"],
  format,
  openPickerAriaLabel,
  "data-testid": dataTestId,
  "aria-label": ariaLabel,
  ...props
}) {
  const fieldLabel = useTranslationWithFallback("c4r.form.time", label);
  const chooseDateAriaLabel = useTranslationWithFallback(
    "c4r.form.chooseDate",
    openPickerAriaLabel
  );
  const inputRef = useRef(null);
  const [inputWidth, setInputWidth] = useState(0);
  useEffect(() => {
    if (!inputRef.current) return;
    const resizeObserver = new ResizeObserver((entries) => {
      var _a;
      const width = (_a = entries[0]) == null ? void 0 : _a.contentRect.width;
      if (width) {
        setInputWidth(width);
      }
    });
    resizeObserver.observe(inputRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  return /* @__PURE__ */ jsx(
    DateFieldContainer,
    {
      size,
      variant,
      readOnly,
      "data-name": "time-picker",
      "data-testid": dataTestId ?? "time-picker",
      "aria-label": ariaLabel,
      children: /* @__PURE__ */ jsx(
        TimePicker$1,
        {
          ...props,
          ref: inputRef,
          label: /* @__PURE__ */ jsx(
            LabelWithIndicator,
            {
              label: fieldLabel,
              type,
              icon: labelHelpTooltip && /* @__PURE__ */ jsx(Tooltip, { title: labelHelpTooltip, children: /* @__PURE__ */ jsx(HelpOutline, { htmlColor: "text.secondary" }) })
            }
          ),
          views: ["hours"],
          format: getDateTimeFormat(views, false, ampm, format),
          slotProps: {
            textField: {
              variant,
              helperText,
              placeholder,
              size,
              error: error ?? void 0,
              // undefined is needed to allow the component to control the error state for the default validation
              inputProps: {
                "data-testid": "time-picker-input"
              }
            },
            field: {
              clearable: !!handleClear,
              onClear: handleClear
            },
            popper: {
              placement: "bottom-end"
            },
            layout: {
              sx: {
                width: inputWidth
              }
            },
            ...slotProps
          },
          slots: {
            clearButton: (props2) => /* @__PURE__ */ jsx(ClearButton, { ...props2, size, variant }),
            openPickerButton: (props2) => /* @__PURE__ */ jsx(
              IconButton$1,
              {
                ...props2,
                size,
                "aria-label": chooseDateAriaLabel
              }
            ),
            ...slots
          },
          disableOpenPicker: !showClock,
          readOnly,
          ampm
        }
      )
    }
  );
}
function DateTimePicker({
  handleClear,
  variant = "outlined",
  size = "small",
  label,
  labelHelpTooltip,
  type,
  helperText,
  placeholder,
  error,
  showCalendar = true,
  readOnly,
  slotProps,
  slots,
  ampm = true,
  views = ["hours", "minutes"],
  format,
  openPickerAriaLabel,
  "data-testid": dataTestId,
  "aria-label": ariaLabel,
  ...props
}) {
  const fieldLabel = useTranslationWithFallback("c4r.form.time", label);
  const chooseDateAriaLabel = useTranslationWithFallback(
    "c4r.form.chooseDate",
    openPickerAriaLabel
  );
  return /* @__PURE__ */ jsx(
    DateFieldContainer,
    {
      size,
      variant,
      readOnly,
      "data-name": "date-time-picker",
      "data-testid": dataTestId ?? "date-time-picker",
      "aria-label": ariaLabel,
      children: /* @__PURE__ */ jsx(
        DateTimePicker$1,
        {
          ...props,
          label: /* @__PURE__ */ jsx(
            LabelWithIndicator,
            {
              label: fieldLabel,
              type,
              icon: labelHelpTooltip && /* @__PURE__ */ jsx(Tooltip, { title: labelHelpTooltip, children: /* @__PURE__ */ jsx(HelpOutline, { htmlColor: "text.secondary" }) })
            }
          ),
          views: ["year", "month", "day", "hours"],
          format: getDateTimeFormat(views, true, ampm, format),
          slotProps: {
            textField: {
              variant,
              helperText,
              placeholder,
              size,
              error: error ?? void 0,
              // undefined is needed to allow the component to control the error state for the default validation
              inputProps: {
                "data-testid": "date-time-picker-input"
              }
            },
            field: {
              clearable: !!handleClear,
              onClear: handleClear
            },
            ...slotProps
          },
          slots: {
            clearButton: (props2) => /* @__PURE__ */ jsx(ClearButton, { ...props2, size, variant }),
            openPickerButton: (props2) => /* @__PURE__ */ jsx(
              IconButton$1,
              {
                ...props2,
                size,
                "aria-label": chooseDateAriaLabel
              }
            ),
            ...slots
          },
          disableOpenPicker: !showCalendar,
          readOnly,
          ampm
        }
      )
    }
  );
}
const DEFAULT_ITEMS = [{ outlinedBullet: false, value: "" }];
const Content$2 = styled("ul")(({ theme }) => ({
  listStyle: "none",
  paddingLeft: 0,
  margin: theme.spacing(0.5, 0, 0, 0)
}));
const Entry = styled("li")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "&:not(:last-child)": {
    marginBottom: theme.spacing(0.5)
  }
}));
const Bullet = styled("span")(({ theme }) => ({
  width: theme.spacing(1),
  height: theme.spacing(1),
  marginRight: theme.spacing(0.5),
  border: `2px solid ${theme.palette.qualitative.bold[1]}`,
  borderRadius: "50%",
  backgroundColor: theme.palette.qualitative.bold[1]
}));
const Category = styled(Typography)(({ theme }) => ({
  minWidth: theme.spacing(10),
  marginRight: theme.spacing(1.5)
}));
function TooltipData({
  items = DEFAULT_ITEMS,
  title
}) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    title && /* @__PURE__ */ jsx(Typography, { color: "inherit", variant: "caption", weight: "medium", children: title }),
    /* @__PURE__ */ jsx(Content$2, { children: items.map((item, index) => /* @__PURE__ */ jsxs(Entry, { children: [
      /* @__PURE__ */ jsx(
        Bullet,
        {
          style: {
            backgroundColor: `${item.outlinedBullet ? "transparent" : item.color}`,
            borderColor: item.color
          },
          role: "presentation",
          "data-bullet": item.outlinedBullet ? "outlined" : "filled"
        }
      ),
      item.category && /* @__PURE__ */ jsx(Category, { color: "inherit", variant: "caption", children: item.category }),
      /* @__PURE__ */ jsx(Typography, { color: "inherit", variant: "caption", weight: "medium", children: item.value })
    ] }, index)) })
  ] });
}
const AccordionContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "variant"
})(({ variant, theme }) => ({
  width: "100%",
  borderRadius: theme.spacing(0.5),
  ...variant === "outlined" && {
    backgroundColor: theme.palette.background.paper,
    boxShadow: `inset 0 0 0 1px ${theme.palette.divider}`
  }
}));
function _AccordionGroup({
  variant = "standard",
  items,
  "aria-label": ariaLabel,
  "data-testid": dataTestId,
  ...otherProps
}, ref) {
  return /* @__PURE__ */ jsx(
    AccordionContainer,
    {
      ...otherProps,
      variant,
      "aria-label": ariaLabel,
      "data-testid": dataTestId,
      "data-variant": variant,
      "data-name": "accordion-group",
      ref,
      children: items.map((item, index) => /* @__PURE__ */ jsxs(
        Accordion,
        {
          disabled: item.disabled,
          defaultExpanded: item.defaultExpanded,
          onChange: item.onChange,
          children: [
            /* @__PURE__ */ jsx(
              AccordionSummary,
              {
                "aria-controls": `${index}-content`,
                id: `${index}-header`,
                children: item.summary
              }
            ),
            /* @__PURE__ */ jsx(AccordionDetails, { children: item.content })
          ]
        },
        index
      ))
    }
  );
}
const AccordionGroup = forwardRef(_AccordionGroup);
function _Avatar({
  size,
  disabled,
  "aria-label": ariaLabel,
  "data-testid": dataTestId,
  ...otherProps
}, ref) {
  return /* @__PURE__ */ jsx(
    Avatar$1,
    {
      ...otherProps,
      ref,
      size,
      "aria-disabled": disabled,
      disabled,
      "aria-label": ariaLabel,
      "data-testid": dataTestId,
      "data-size": size,
      "data-name": "avatar"
    }
  );
}
const Avatar = forwardRef(_Avatar);
const StyledMenu = styled(Menu$2, {
  shouldForwardProp: (prop) => !["extended", "width", "height"].includes(prop)
})(({ extended, width, height }) => ({
  ...extended && {
    ".MuiMenuItem-root": {
      minHeight: MENU_ITEM_SIZE_EXTENDED
    }
  },
  ...width && {
    ".MuiList-root": {
      width,
      minWidth: width
    }
  },
  ...height && {
    ".MuiMenu-paper": {
      overflow: "hidden"
    },
    ".MuiList-root": {
      maxHeight: height
    }
  }
}));
function _Menu({ extended, width, height, MenuListProps, ...otherProps }, ref) {
  return /* @__PURE__ */ jsx(
    StyledMenu,
    {
      ...otherProps,
      ref,
      "data-name": "menu",
      width,
      height,
      extended,
      MenuListProps: {
        ...MenuListProps,
        "data-width": width,
        "data-height": height,
        "data-extended": extended
      }
    }
  );
}
const Menu = forwardRef(_Menu);
const StyledMenuList = styled(MenuList$1, {
  shouldForwardProp: (prop) => !["extended", "width", "height"].includes(prop)
})(({ extended, width, height }) => ({
  ...extended && {
    ".MuiMenuItem-root": {
      minHeight: MENU_ITEM_SIZE_EXTENDED
    }
  },
  "&.MuiList-root": {
    ...width && {
      width,
      minWidth: width
    },
    ...height && {
      maxHeight: height
    }
  }
}));
function _MenuList({ extended, width, height, ...otherProps }, ref) {
  return /* @__PURE__ */ jsx(
    StyledMenuList,
    {
      ...otherProps,
      ref,
      width,
      height,
      extended,
      "data-name": "menu-list",
      "data-width": width,
      "data-height": height,
      "data-extended": extended
    }
  );
}
const MenuList = forwardRef(_MenuList);
const FilterDropdownMenuItem = ({
  item,
  selectedValue,
  dense,
  extended,
  onItemChange
}) => {
  const {
    id,
    label,
    description,
    startAdornment,
    endAdornment,
    tooltipLabel,
    tooltipPlacement,
    disabled,
    "aria-label": ariaLabel,
    hidden,
    destructive,
    subtitle,
    divider,
    fixed,
    selected,
    iconColor
  } = item;
  const [menuItemId] = useState(() => `filter-dropdown-item-${uniqueId()}`);
  const isSelected = selected || (selectedValue == null ? void 0 : selectedValue.id) === id;
  if (hidden) return null;
  return /* @__PURE__ */ jsx(Tooltip, { title: tooltipLabel, placement: tooltipPlacement, children: /* @__PURE__ */ jsxs(
    MenuItem$1,
    {
      onClick: disabled ? void 0 : (event) => onItemChange(item, event),
      selected: isSelected,
      dense,
      extended,
      disabled,
      destructive,
      subtitle,
      divider,
      fixed,
      iconColor,
      "aria-label": ariaLabel,
      "aria-labelledby": menuItemId,
      "aria-selected": isSelected,
      sx: {
        ...disabled && tooltipLabel && {
          // This ensures the Tooltip is shown when disabled, without wrapping it with a span/div,
          // otherwise this will invalid from an A11Y perspective plus not navigable through the keyboard
          pointerEvents: "auto !important"
        }
      },
      children: [
        startAdornment && /* @__PURE__ */ jsx(ListItemIcon, { children: startAdornment }),
        /* @__PURE__ */ jsx(
          ListItemText,
          {
            primary: label,
            secondary: description,
            primaryTypographyProps: {
              variant: "body2",
              id: menuItemId
            }
          }
        ),
        endAdornment && /* @__PURE__ */ jsx(ListItemIcon, { children: endAdornment })
      ]
    }
  ) });
};
const ButtonWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isOpen" && prop !== "buttonColor"
})(({ isOpen, theme, buttonColor }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  ...isOpen && {
    "& .MuiButtonBase-root": {
      backgroundColor: theme.palette.action.hover
    }
  },
  ...buttonColor === "secondary" && {
    "& button": {
      color: theme.palette.text.secondary
    }
  }
}));
function _FilterDropdown({
  menuItems,
  onClickItem,
  value,
  defaultValue = menuItems[0],
  menuTitle,
  placeholder,
  disabled,
  icon,
  label,
  buttonSize,
  buttonColor = "primary",
  dense = false,
  extended = false,
  "aria-label": ariaLabel,
  responsive,
  tooltipLabel,
  tooltipPlacement,
  tooltipProps,
  buttonProps,
  iconButtonProps,
  slotProps,
  MenuListProps,
  ...props
}, ref) {
  const [selected_, setSelected] = useState(defaultValue || void 0);
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = !!anchorEl;
  const selected = value ?? selected_;
  const isTablet = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const isIcon = Boolean(icon) && (!responsive || isTablet);
  const menuLabel = label || (selected == null ? void 0 : selected.alternativeLabel) || (selected == null ? void 0 : selected.label) || placeholder;
  const [buttonId] = useState(() => `filter-dropdown-button-${uniqueId()}`);
  const [menuId] = useState(() => `filter-dropdown-menu-${uniqueId()}`);
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChange = (item, event) => {
    setSelected(item);
    onClickItem(item, event);
    handleClose();
  };
  const commonButtonProps = {
    onClick: handleOpen,
    disabled,
    size: buttonSize,
    color: "default",
    "aria-label": ariaLabel,
    id: buttonId,
    "aria-controls": isOpen ? menuId : void 0,
    "aria-haspopup": !disabled,
    "aria-expanded": isOpen,
    "data-color": buttonColor
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Tooltip,
      {
        title: tooltipLabel,
        placement: tooltipPlacement,
        ...tooltipProps,
        children: /* @__PURE__ */ jsx(ButtonWrapper, { isOpen, buttonColor, ref, children: isIcon ? /* @__PURE__ */ jsx(
          IconButton,
          {
            ...commonButtonProps,
            icon,
            ...iconButtonProps
          }
        ) : /* @__PURE__ */ jsx(
          Button,
          {
            ...commonButtonProps,
            endIcon: isOpen ? /* @__PURE__ */ jsx(ArrowUp, {}) : /* @__PURE__ */ jsx(ArrowDown, {}),
            ...buttonProps,
            children: menuLabel
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsxs(
      Menu,
      {
        id: menuId,
        transformOrigin: { vertical: "top", horizontal: "right" },
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
        ...props,
        anchorEl,
        open: isOpen,
        onClose: handleClose,
        slotProps: {
          ...slotProps,
          paper: {
            "data-name": "filter-dropdown",
            ...slotProps == null ? void 0 : slotProps.paper
          }
        },
        MenuListProps: {
          "aria-labelledby": buttonId,
          ...dense && {
            "data-dense": dense
          },
          autoFocus: true,
          // To allow keyboard navigation
          ...MenuListProps
        },
        children: [
          menuTitle && /* @__PURE__ */ jsx(MenuItem$1, { subtitle: true, children: menuTitle }),
          menuItems.map((item, index) => {
            return /* @__PURE__ */ jsx(
              FilterDropdownMenuItem,
              {
                item,
                selectedValue: selected,
                dense,
                extended,
                onItemChange: handleChange
              },
              index
            );
          })
        ]
      }
    )
  ] });
}
const FilterDropdown = forwardRef(
  _FilterDropdown
);
const SearchIcon = styled(Search, {
  shouldForwardProp: (prop) => prop !== "minimized" && prop !== "disabled"
})(
  ({ theme, minimized, disabled }) => ({
    cursor: !disabled && minimized ? "pointer" : "inherit",
    width: ICON_SIZE_MEDIUM,
    height: ICON_SIZE_MEDIUM,
    path: {
      fillOpacity: 1,
      fill: disabled ? theme.palette.text.disabled : theme.palette.text.secondary
    }
  })
);
const ClearSearchIcon = styled(Cancel)(({ theme }) => ({
  color: `${theme.palette.text.hint} !important`
}));
const LoadingSearchIcon = styled(CircularProgress$1)(({ theme }) => ({
  svg: {
    color: `${theme.palette.primary.main} !important`
  }
}));
const SearchInputAdornment = styled(InputAdornment, {
  shouldForwardProp: (prop) => prop !== "minimized" && prop !== "expanded"
})(
  ({ theme, minimized, expanded }) => ({
    // Start adornment
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.short
    }),
    "&.MuiInputAdornment-positionStart": {
      marginLeft: minimized ? theme.spacing(2) : void 0,
      "&.MuiInputAdornment-sizeSmall": {
        marginLeft: minimized ? theme.spacing(1) : void 0
      }
    },
    // End adornment
    "&.MuiInputAdornment-positionEnd": {
      minWidth: theme.spacing(4),
      "&.MuiInputAdornment-sizeSmall": {
        minWidth: theme.spacing(3)
      }
    },
    ...expanded && !minimized && {
      "&.MuiInputAdornment-root": {
        minWidth: theme.spacing(9),
        "&.MuiInputAdornment-sizeSmall": {
          minWidth: theme.spacing(7)
        }
      }
    }
  })
);
const SearchFieldBase = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "minimized" && prop !== "isInputFocused" && prop !== "emphasis"
})(({ theme, emphasis = "filled", minimized, isInputFocused }) => ({
  "&.MuiTextField-root .MuiInputBase-root": {
    paddingRight: theme.spacing(1),
    transition: theme.transitions.create(["width", "padding"], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard
    }),
    "&.MuiInputBase-sizeSmall": {
      paddingRight: theme.spacing(0.5)
    },
    "&:before": {
      border: "none !important",
      "&:hover": {
        border: "none !important"
      }
    },
    // Input
    "& .MuiInputBase-input": {
      pointerEvents: isInputFocused ? "auto" : "none",
      // Fix Chrome scroll issue https://issues.chromium.org/issues/41245282
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.standard
      })
    },
    // Error state
    "&.Mui-error": {
      "&::after": {
        borderColor: "transparent !important"
      }
    },
    ...minimized && {
      display: "flex",
      alignItems: "center",
      padding: 0,
      width: theme.spacing(6),
      cursor: "pointer",
      "& .MuiInputBase-input": {
        width: 0
      },
      "&.MuiInputBase-sizeSmall": {
        padding: 0,
        width: theme.spacing(4)
      }
    }
  },
  // Variants
  ...emphasis === "filled" && {
    "& .MuiInputBase-root": {
      backgroundColor: minimized ? "transparent !important" : void 0,
      "&:hover": {
        backgroundColor: `${theme.palette.action.hover} !important`
      },
      // not disabled
      "&:not(.Mui-disabled):hover": {
        backgroundColor: `${theme.palette.action.hover} !important`
      }
    }
  },
  ...emphasis === "transparent" && {
    "& .MuiInputBase-root": {
      backgroundColor: "transparent !important",
      "&:hover": {
        backgroundColor: minimized ? `${theme.palette.action.hover} !important` : "transparent !important"
      },
      "&.Mui-disabled": {
        backgroundColor: "transparent !important"
      }
    }
  },
  ...emphasis === "floating" && {
    "& .MuiInputBase-root": {
      backgroundColor: `${theme.palette.background.paper} !important`,
      boxShadow: theme.shadows[1],
      "&:hover": {
        backgroundColor: minimized ? `${theme.palette.action.hover} !important` : `${theme.palette.background.paper} !important`
      },
      "&.Mui-disabled": {
        backgroundColor: `${theme.palette.background.paper} !important`
      }
    }
  }
}));
const SearchFieldEndAdornment = ({
  disabled,
  showClearButton = true,
  loading,
  size,
  endAdornment,
  clearButton,
  clearButtonLabel,
  onClear
}) => {
  if (!showClearButton && !endAdornment && !loading) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    SearchInputAdornment,
    {
      position: "end",
      expanded: Boolean(endAdornment && showClearButton),
      children: /* @__PURE__ */ jsxs(
        Stack,
        {
          direction: "row",
          spacing: 1,
          sx: {
            alignItems: "center"
          },
          children: [
            loading ? /* @__PURE__ */ jsx(LoadingSearchIcon, { size: ICON_SIZE_MEDIUM }) : showClearButton ? clearButton ?? /* @__PURE__ */ jsx(
              IconButton,
              {
                onClick: onClear,
                size,
                color: "default",
                disabled,
                tooltip: clearButtonLabel,
                "aria-label": clearButtonLabel,
                icon: /* @__PURE__ */ jsx(ClearSearchIcon, {})
              }
            ) : null,
            endAdornment
          ]
        }
      )
    }
  );
};
const SearchFieldStartAdornment = ({
  minimized,
  loading,
  startAdornment,
  disabled
}) => {
  return /* @__PURE__ */ jsx(SearchInputAdornment, { position: "start", minimized, children: loading && minimized ? /* @__PURE__ */ jsx(LoadingSearchIcon, { size: ICON_SIZE_MEDIUM }) : startAdornment || /* @__PURE__ */ jsx(SearchIcon, { disabled, minimized }) });
};
function _SearchField({
  value,
  defaultValue,
  placeholder,
  disabled,
  minimized = false,
  loading = false,
  variant = "filled",
  size = "small",
  InputProps,
  inputProps,
  startAdornment,
  endAdornment,
  onFocus,
  onBlur,
  onChange,
  onClick,
  onResetSearch,
  showClearButton = true,
  clearButtonLabel,
  clearButton,
  ...otherProps
}, ref) {
  const [isInputFocused, setIsInputFocused] = useState(false);
  const clearButtonVisibility = !disabled && Boolean(value ?? defaultValue) && showClearButton;
  const clearButtonLabelValue = useTranslationWithFallback(
    "c4r.button.clear",
    clearButtonLabel
  );
  const handleFocus = (event) => {
    setIsInputFocused(true);
    onFocus == null ? void 0 : onFocus(event);
  };
  const handleBlur = (event) => {
    setIsInputFocused(false);
    onBlur == null ? void 0 : onBlur(event);
  };
  const handleClear = () => {
    onResetSearch == null ? void 0 : onResetSearch();
    onChange == null ? void 0 : onChange({ target: { value: "" } });
  };
  return /* @__PURE__ */ jsx(
    SearchFieldBase,
    {
      defaultValue,
      value: minimized ? "" : value,
      placeholder: minimized ? "" : placeholder,
      onChange,
      onClick,
      variant: "filled",
      emphasis: variant,
      size,
      focused: false,
      isInputFocused,
      disabled,
      minimized,
      InputProps: {
        onFocus: handleFocus,
        onBlur: handleBlur,
        startAdornment: /* @__PURE__ */ jsx(
          SearchFieldStartAdornment,
          {
            minimized,
            loading,
            disabled,
            startAdornment
          }
        ),
        endAdornment: !minimized && /* @__PURE__ */ jsx(
          SearchFieldEndAdornment,
          {
            disabled,
            loading,
            showClearButton: clearButtonVisibility,
            clearButton,
            clearButtonLabel: clearButtonLabelValue,
            onClear: handleClear,
            size,
            endAdornment
          }
        ),
        ...InputProps
      },
      inputProps: {
        role: "searchbox",
        ...inputProps
      },
      role: "search",
      "data-variant": variant,
      "data-name": "search-field",
      ref,
      ...otherProps
    }
  );
}
const SearchField = forwardRef(_SearchField);
const MAX_WIDTH = 480;
const SnackbarRoot = styled(Snackbar$1)(({ theme }) => ({
  bottom: theme.spacing(2),
  right: theme.spacing(2),
  left: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    bottom: theme.spacing(4),
    right: "auto",
    left: "50%",
    width: "100%",
    maxWidth: `${MAX_WIDTH}px`
  }
}));
const Content$1 = styled(Box, {
  shouldForwardProp: (prop) => prop !== "autoWidth"
})(({ autoWidth, theme }) => ({
  minWidth: "100%",
  maxWidth: `${MAX_WIDTH}px`,
  margin: theme.spacing(0, 1),
  ...autoWidth && {
    minWidth: "auto"
  },
  [theme.breakpoints.up("sm")]: {
    minWidth: theme.spacing(40),
    ...autoWidth && {
      minWidth: "auto"
    }
  }
}));
const Alert = styled(Alert$1, {
  shouldForwardProp: (prop) => !["hasActions", "closeable"].includes(prop)
})(({ hasActions, closeable, icon, theme }) => ({
  position: "relative",
  display: "flex",
  flexWrap: "wrap",
  columnGap: theme.spacing(1),
  rowGap: theme.spacing(0.25),
  padding: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  color: theme.palette.common.white,
  backgroundColor: theme.palette.common.black,
  ".MuiAlert-message": {
    padding: theme.spacing(0.75, 0)
  },
  ".MuiAlert-message .MuiTypography-root, .MuiAlert-icon": {
    color: theme.palette.common.white
  },
  ".MuiAlert-message .MuiTypography-root:not(.MuiAlertTitle-root)": {
    ...theme.typography.body2
  },
  ".MuiAlert-message .MuiCircularProgress-circle": {
    color: theme.palette.common.white
  },
  ".MuiAlert-icon": {
    position: "absolute",
    top: theme.spacing(1),
    left: theme.spacing(1.5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: theme.spacing(3),
    marginTop: theme.spacing(0.5)
  },
  "&.MuiAlert-standardError": {
    backgroundColor: theme.palette.error.main
  },
  ...icon !== false && {
    paddingLeft: theme.spacing(5.5)
  },
  ...closeable && {
    paddingRight: theme.spacing(6)
  },
  ...!closeable && !hasActions && {
    paddingRight: theme.spacing(1.5)
  },
  ...hasActions && {
    ".MuiAlert-message": {
      minWidth: "fit-content",
      padding: theme.spacing(0.75, 0)
    }
  }
}));
const CloseButtonWrapper = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(1),
  right: theme.spacing(1),
  "& button:hover, & button:focus-visible": {
    backgroundColor: theme.palette.white[8]
  },
  svg: {
    color: theme.palette.white[60]
  }
}));
function Snackbar({
  severity = "neutral",
  autoHideDuration = NOTIFICATION_DURATION_IN_MS,
  closeable = true,
  children,
  title,
  action,
  open,
  onClose = () => void 0,
  autoWidth,
  icon,
  closeTooltipText,
  ...rest
}) {
  const closeTooltipLabel = useTranslationWithFallback(
    "c4r.button.close",
    closeTooltipText
  );
  const isNeutral = severity === "neutral";
  const disabledIcon = icon === false || isNeutral && !icon;
  const disabledAutoHide = autoHideDuration === null;
  const duration = disabledAutoHide ? null : autoHideDuration || NOTIFICATION_DURATION_IN_MS;
  return /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(
    SnackbarRoot,
    {
      ...rest,
      open,
      autoHideDuration: duration,
      onClose,
      TransitionComponent: autoWidth ? Fade : Slide,
      "data-auto-width": autoWidth,
      children: /* @__PURE__ */ jsxs(
        Content$1,
        {
          sx: {
            position: "relative"
          },
          autoWidth,
          children: [
            /* @__PURE__ */ jsx(
              Alert,
              {
                severity,
                action,
                icon: disabledIcon ? false : icon,
                elevation: 6,
                hasActions: !!action,
                closeable,
                title,
                children
              }
            ),
            closeable && /* @__PURE__ */ jsx(CloseButtonWrapper, { children: /* @__PURE__ */ jsx(
              IconButton,
              {
                color: "default",
                onClick: (e) => onClose(e, "timeout"),
                icon: /* @__PURE__ */ jsx(CloseOutlined, {}),
                tooltip: closeTooltipLabel
              }
            ) })
          ]
        }
      )
    }
  ) });
}
function colorProps(color, variant, theme, disabled) {
  if (disabled) {
    if (variant === "outlined") {
      return {
        color: theme.palette.text.disabled,
        backgroundColor: theme.palette.black[4],
        borderColor: theme.palette.action.focus
      };
    }
    return {
      color: theme.palette.text.disabled,
      backgroundColor: theme.palette.action.disabledBackground,
      borderColor: "transparent"
    };
  }
  switch (color) {
    case "default":
      if (variant === "outlined") {
        return {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.black["4"],
          borderColor: theme.palette.divider
        };
      }
      return {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.default.main,
        borderColor: "transparent"
      };
    case "primary":
      if (variant === "outlined") {
        return {
          color: theme.palette.primary.main,
          backgroundColor: theme.palette.primary.relatedLight,
          borderColor: theme.palette.primary.main
        };
      }
      return {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        borderColor: "transparent"
      };
    case "secondary":
      if (variant === "outlined") {
        return {
          color: theme.palette.secondary.main,
          backgroundColor: theme.palette.secondary.relatedLight,
          borderColor: theme.palette.secondary.main
        };
      }
      return {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.main,
        borderColor: "transparent"
      };
    case "success":
      if (variant === "outlined") {
        return {
          color: theme.palette.success.main,
          backgroundColor: theme.palette.success.relatedLight,
          borderColor: theme.palette.success.main
        };
      }
      return {
        color: theme.palette.success.main,
        backgroundColor: theme.palette.success.relatedLight,
        borderColor: "transparent"
      };
    case "warning":
      if (variant === "outlined") {
        return {
          color: theme.palette.warning.main,
          backgroundColor: theme.palette.warning.relatedLight,
          borderColor: theme.palette.warning.main
        };
      }
      return {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.warning.main,
        borderColor: "transparent"
      };
    case "error":
      if (variant === "outlined") {
        return {
          color: theme.palette.error.main,
          backgroundColor: theme.palette.error.relatedLight,
          borderColor: theme.palette.error.main
        };
      }
      return {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.error.main,
        borderColor: "transparent"
      };
  }
}
const TagRoot = styled("div", {
  shouldForwardProp: (prop) => !["color", "variant", "disabled"].includes(prop)
})(({
  color,
  variant,
  disabled,
  theme
}) => {
  return {
    display: "inline-flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
    padding: theme.spacing(0, 0.5),
    borderRadius: theme.spacing(0.25),
    gap: theme.spacing(0.5),
    maxWidth: "100%",
    height: theme.spacing(2),
    borderWidth: "1px",
    borderStyle: "solid",
    ...colorProps(color ?? "primary", variant ?? "filled", theme, disabled),
    '.Mui-selected &, [aria-selected="true"] &': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.background,
      ".MuiTypography-root": {
        color: theme.palette.primary.main
      }
    }
  };
});
const TagIcon = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "& svg": {
    width: theme.spacing(ICON_SIZE_SMALL),
    height: theme.spacing(ICON_SIZE_SMALL),
    "& g": {
      fill: "currentColor"
    }
  }
}));
const TagLabel = styled("div", {
  shouldForwardProp: (prop) => !["type"].includes(prop)
})(({ type, theme }) => ({
  display: "flex",
  alignItems: "center",
  ...ellipsisStyles,
  paddingTop: type === "code" ? theme.spacing(0.25) : void 0
}));
function _Tag({
  label,
  color = "primary",
  variant = "filled",
  icon,
  type = "default",
  typographyProps,
  noWrap = true,
  disabled,
  ...otherProps
}, ref) {
  const typeCode = type === "code";
  return /* @__PURE__ */ jsxs(
    TagRoot,
    {
      ref,
      className: "CartoTag-root",
      color,
      variant,
      disabled,
      "aria-disabled": disabled,
      "data-color": color,
      "data-variant": variant,
      "data-type": type,
      "data-name": "tag",
      ...otherProps,
      children: [
        icon && /* @__PURE__ */ jsx(TagIcon, { children: icon }),
        /* @__PURE__ */ jsx(TagLabel, { type, children: /* @__PURE__ */ jsx(
          Typography,
          {
            component: "span",
            color: "inherit",
            variant: typeCode ? "code3" : "caption",
            weight: typeCode ? "strong" : "medium",
            noWrap,
            ...typographyProps,
            children: label
          }
        ) })
      ]
    }
  );
}
const Tag = forwardRef(_Tag);
const StyledUploadField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "cursor"
})(
  ({ cursor, theme }) => ({
    "&.MuiTextField-root .MuiInputBase-root": {
      cursor,
      paddingRight: theme.spacing(1),
      "& input": {
        cursor
      },
      "&.Mui-disabled": {
        pointerEvents: "none",
        "& .MuiButtonBase-root": {
          color: theme.palette.text.disabled
        }
      },
      "&.MuiInputBase-sizeSmall": {
        paddingRight: theme.spacing(0.5)
      }
    },
    "& .MuiFormLabel-root": {
      cursor,
      "&.Mui-disabled": {
        pointerEvents: "none"
      }
    }
  })
);
function FilesAction({
  buttonText,
  hasFiles,
  size,
  error,
  disabled,
  handleReset,
  handleOpen,
  inProgress
}) {
  return /* @__PURE__ */ jsx(InputAdornment, { position: "end", children: inProgress ? /* @__PURE__ */ jsx(IconButton$1, { "aria-label": "Loading", disabled: true, size, children: /* @__PURE__ */ jsx(CircularProgress$1, { size: 18 }) }) : !hasFiles ? /* @__PURE__ */ jsx(
    Button$1,
    {
      onClick: handleOpen,
      size,
      variant: "text",
      color: error ? "default" : "primary",
      disabled,
      "data-error": error,
      children: buttonText
    }
  ) : /* @__PURE__ */ jsx(
    IconButton$1,
    {
      onClick: handleReset,
      size,
      "aria-label": "Delete",
      disabled,
      children: /* @__PURE__ */ jsx(Cancel, {})
    }
  ) });
}
function _UploadFieldBase({
  name,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  multiple,
  // multiple prop defined here for compatibility with cloud-native but not used in the component
  handleReset,
  handleOpen,
  dragOver,
  error,
  placeholder,
  focused,
  buttonText = "Browse",
  inProgress,
  InputProps,
  size = "small",
  hasFiles,
  cursor = "pointer",
  "data-testid": dataTestId,
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(
    StyledUploadField,
    {
      ...props,
      ref,
      size,
      error,
      placeholder,
      focused: focused ?? dragOver,
      cursor,
      "data-testid": dataTestId,
      InputProps: {
        ...InputProps,
        name,
        // multiple prop cannot be used here because it is not a valid prop for TextField InputProps
        // not used for any UI logic
        readOnly: true,
        endAdornment: /* @__PURE__ */ jsx(
          FilesAction,
          {
            buttonText,
            hasFiles,
            size,
            error,
            disabled: !!dragOver,
            handleReset,
            handleOpen,
            inProgress
          }
        )
      },
      "data-cursor": cursor,
      "data-drag-over": dragOver,
      "data-name": "upload-field-base"
    }
  );
}
const UploadFieldBase = forwardRef(_UploadFieldBase);
function useFileUpload({
  onChange,
  files,
  multiple,
  placeholder,
  uploadInputRef,
  filesSelectedText,
  dragPlaceholderText,
  dragActivePlaceholderText
}) {
  const filesSelectedLabel = useTranslationWithFallback(
    "c4r.form.filesSelected",
    filesSelectedText,
    { count: (files == null ? void 0 : files.length) ?? 0 }
  );
  const dragPlaceholderLabel = useTranslationWithFallback(
    "c4r.form.dragPlaceholder",
    dragPlaceholderText,
    { count: multiple ? 0 : 1 }
  );
  const dragActivePlaceholderLabel = useTranslationWithFallback(
    "c4r.form.dragActivePlaceholder",
    dragActivePlaceholderText,
    { count: multiple ? 0 : 1 }
  );
  const [filesText, setFilesText] = useState("");
  const [dragOver, setDragOver] = useState(false);
  useEffect(() => {
    if (!files || files.length === 0) {
      setFilesText("");
    } else if (files.length === 1) {
      setFilesText(files[0].name);
    } else {
      setFilesText(filesSelectedLabel);
    }
  }, [files, filesSelectedLabel]);
  const handleBrowse = () => {
    var _a;
    (_a = uploadInputRef.current) == null ? void 0 : _a.click();
  };
  const handleDragOver = (event) => {
    event.preventDefault();
    setDragOver(true);
  };
  const handleDragLeave = (event) => {
    event.preventDefault();
    setDragOver(false);
  };
  const handleDrop = (event) => {
    event.preventDefault();
    setDragOver(false);
    const items = event.dataTransfer.items;
    const newFiles = getAllFiles(items);
    onChange == null ? void 0 : onChange(newFiles);
  };
  const getAllFiles = (items) => {
    const newFiles = [];
    for (const item of Array.from(items)) {
      if (item.kind === "file") {
        const file = item.getAsFile();
        newFiles.push(file);
      }
    }
    return newFiles;
  };
  const handleFiles = (event) => {
    const newFiles = Array.from(event.target.files);
    onChange == null ? void 0 : onChange(newFiles);
  };
  const handleReset = (event) => {
    event.stopPropagation();
    setFilesText("");
    onChange == null ? void 0 : onChange([]);
  };
  const getPlaceholder = useMemo(() => {
    if (dragOver) {
      return dragActivePlaceholderLabel;
    }
    return placeholder ?? dragPlaceholderLabel;
  }, [dragOver, placeholder, dragPlaceholderLabel, dragActivePlaceholderLabel]);
  const inputEvents = {
    onDragOver: handleDragOver,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop,
    onClick: handleBrowse
  };
  return {
    filesText,
    getPlaceholder,
    dragOver,
    inputEvents,
    handleFiles,
    handleReset
  };
}
const DEFAULT_ACCEPT = ["application/JSON"];
function _UploadField({
  name,
  buttonText,
  accept: _accept,
  files,
  inProgress,
  onChange,
  multiple,
  placeholder,
  error,
  focused,
  nativeInputProps,
  "data-testid": dataTestId,
  ...props
}, ref) {
  const accept = _accept ?? DEFAULT_ACCEPT;
  const uploadInputRef = useRef(null);
  const {
    filesText,
    getPlaceholder,
    dragOver,
    inputEvents,
    handleFiles,
    handleReset
  } = useFileUpload({
    uploadInputRef,
    files,
    onChange,
    multiple,
    placeholder
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      UploadFieldBase,
      {
        ...props,
        ref,
        placeholder: getPlaceholder,
        value: filesText,
        error,
        focused: focused ?? dragOver,
        handleReset,
        dragOver,
        inProgress,
        hasFiles: Boolean(filesText),
        InputProps: inputEvents,
        buttonText,
        "data-testid": dataTestId
      }
    ),
    /* @__PURE__ */ jsx(
      "input",
      {
        ...nativeInputProps,
        ref: uploadInputRef,
        style: { display: "none" },
        type: "file",
        "aria-label": name,
        name,
        accept: String(accept),
        multiple,
        onChange: handleFiles
      }
    )
  ] });
}
const UploadField = forwardRef(_UploadField);
const TooltipRoot = styled(Tooltip)(() => ({
  whiteSpace: "nowrap",
  maxWidth: 999,
  pointerEvents: "auto"
}));
const Content = styled("span", {
  shouldForwardProp: (prop) => !["ellipsisTarget", "lines", "content"].includes(prop)
})(({ ellipsisTarget = "all", lines = 1, content = "block" }) => {
  if (lines > 1) {
    return {
      display: "-webkit-box",
      ...ellipsisStyles,
      whiteSpace: "initial !important",
      WebkitLineClamp: lines,
      WebkitBoxOrient: "vertical",
      "& > *": { display: "block" }
    };
  }
  if (ellipsisTarget === "first-child") {
    return {
      display: "flex",
      flex: "1",
      overflow: "hidden",
      "& > *:nth-of-type(1)": {
        display: "block",
        ...ellipsisStyles,
        marginRight: "-0.15em"
        // Prevent ellipsis separation
      }
    };
  }
  if (content === "flex") {
    return {
      display: "flex",
      flex: "1",
      "& > *": {
        display: "block",
        ...ellipsisStyles
      }
    };
  }
  return {
    display: "block",
    ...ellipsisStyles,
    fontWeight: "inherit",
    "& > *": { display: "inline" }
  };
});
function _EllipsisWithTooltip({
  children,
  tooltipText,
  alwaysShowTooltip,
  content = "block",
  textRef: inputTextRef,
  ellipsisTarget = "all",
  lines = 1,
  "aria-label": ariaLabel,
  contentProps,
  ...otherProps
}, ref) {
  var _a;
  const textElementRef = useRef(null);
  const [overflowing, setOverflowing] = useState(false);
  const textRef = useMemo(
    () => inputTextRef || textElementRef,
    [inputTextRef, textElementRef]
  );
  const getTextContent = (node) => {
    if (typeof node === "string") return node;
    if (typeof node === "number") return String(node);
    if (React.isValidElement(node)) {
      const props = node.props;
      if (props.children) {
        return getTextContent(props.children);
      }
    }
    return "";
  };
  const elementTitle = tooltipText || ((_a = textElementRef.current) == null ? void 0 : _a.innerText) || (alwaysShowTooltip || overflowing ? getTextContent(children) : "");
  useEffect(() => {
    const container = textRef.current;
    if (!container || !children) return;
    if (alwaysShowTooltip) {
      setOverflowing(true);
      return;
    }
    let isOverflowing = false;
    if (lines > 1) {
      isOverflowing = container.scrollHeight > container.clientHeight;
    } else if (ellipsisTarget === "first-child") {
      const children2 = Array.from(container.children);
      const totalWidth = children2.reduce(
        (sum, child) => sum + ((child == null ? void 0 : child.scrollWidth) || 0),
        0
      );
      isOverflowing = totalWidth > container.clientWidth;
    } else {
      const hasContainerOverflow = container.scrollWidth > container.clientWidth;
      const children2 = Array.from(container.children);
      const hasChildOverflow = children2.some(
        (child) => child.scrollWidth > child.clientWidth
      );
      isOverflowing = hasContainerOverflow || hasChildOverflow;
    }
    setOverflowing(isOverflowing);
  }, [textRef, alwaysShowTooltip, children, ellipsisTarget, lines, content]);
  useEffect(() => {
    if (typeof ref === "function") {
      ref(textElementRef.current);
    } else if (ref) {
      ref.current = textElementRef.current;
    }
  }, [ref]);
  return /* @__PURE__ */ jsx(
    TooltipRoot,
    {
      disableFocusListener: !overflowing && !alwaysShowTooltip,
      disableHoverListener: !overflowing && !alwaysShowTooltip,
      disableTouchListener: !overflowing && !alwaysShowTooltip,
      title: elementTitle,
      describeChild: true,
      ...otherProps,
      children: /* @__PURE__ */ jsx(
        Content,
        {
          "aria-label": ariaLabel ?? elementTitle,
          ref: textElementRef,
          ellipsisTarget,
          lines,
          content,
          "data-name": "ellipsis-with-tooltip",
          "data-overflowing": overflowing,
          "data-lines": lines,
          "data-content": content,
          "data-ellipsis-target": ellipsisTarget,
          ...contentProps,
          children
        }
      )
    }
  );
}
const EllipsisWithTooltip = forwardRef(_EllipsisWithTooltip);
export {
  AUTOCOMPLETE_GROUP_HEADER_PROPERTY,
  AccordionGroup,
  Alert$1 as Alert,
  AppBar,
  Autocomplete,
  AutocompleteList,
  Avatar,
  Button,
  CircularProgress,
  CodeAreaDialog,
  CodeAreaDialogConfirmation,
  CodeAreaDialogContent,
  CodeAreaDialogError,
  CodeAreaField,
  CodeAreaFooter,
  CodeAreaHeader,
  CodeAreaInput,
  CodeAreaMarkTextPattern,
  CopiableComponent,
  CopiableInputText,
  CreatableAutocomplete,
  DatePicker,
  DateRangePicker,
  DateTimePicker,
  Dialog,
  DialogActions,
  DialogAlert,
  DialogConfirmation,
  DialogContent,
  DialogContentPadded,
  DialogFooter,
  DialogHeader,
  DialogPaper,
  DialogStepper,
  EllipsisWithTooltip,
  FilterDropdown,
  FilterDropdownMenuItem,
  IconButton,
  LabelWithIndicator,
  L as Link,
  Loader,
  Menu,
  MenuItem$1 as MenuItem,
  MenuItemFilter,
  MenuList,
  MultipleAutocomplete,
  MultipleSelectField,
  PasswordField,
  ScreenReaderOnly,
  SearchField,
  SelectField,
  Snackbar,
  SplitButton,
  a as TablePaginationActions,
  Tag,
  TimePicker,
  ToggleButtonGroup,
  TooltipData,
  Typography,
  UploadField,
  UploadFieldBase,
  copyString,
  createAutocompleteGroupByList,
  dialogDimensionsBySize,
  isAutocompleteListGroupHeader,
  markTextPrecededBySymbol,
  useAutocomplete,
  useAutocompleteRenderOption,
  useCodeAreaAutocompletion,
  useCopyValue
};
